(String.prototype.parse = function (t) {
  var e = new DOMParser().parseFromString(this, "text/html");
  return t ? e.querySelector(t) : e.body.firstElementChild;
}),
  (Element.prototype.trigger = window.trigger =
    function (t, e = null) {
      var i = null == e ? new Event(t) : new CustomEvent(t, { detail: e });
      this.dispatchEvent(i);
    }),
  (Element.prototype.on =
    document.on =
    window.on =
      function (t, e, i) {
        return (
          this.namespaces || (this.namespaces = {}),
          t.split(" ").forEach((t) => {
            (this.namespaces[t] = e),
              this.addEventListener(t.split(".")[0], e, i);
          }),
          this
        );
      }),
  (Element.prototype.off =
    document.off =
    window.off =
      function (t) {
        if (this.namespaces)
          return (
            t.split(" ").forEach((t) => {
              this.removeEventListener(t.split(".")[0], this.namespaces[t]),
                delete this.namespaces[t];
            }),
            this
          );
      }),
  (Element.prototype.index = function () {
    return [...this.parentNode.children].indexOf(this);
  }),
  (Element.prototype.offset = function () {
    var t = this.getBoundingClientRect();
    return { top: t.top + window.scrollY, left: t.left + window.pageXOffset };
  }),
  (Element.prototype.setStyles = function (t = {}) {
    for (const e in t) this.style[e] = t[e];
    return this;
  }),
  (Element.prototype.remove = function () {
    return this.parentNode && this.parentNode.removeChild(this);
  }),
  (NodeList.prototype.on = Array.prototype.on =
    function (t, i, s) {
      this.forEach((e) => {
        e.namespaces || (e.namespaces = {}),
          t.split(" ").forEach((t) => {
            (e.namespaces[t] = i), e.addEventListener(t.split(".")[0], i, s);
          });
      });
    }),
  (NodeList.prototype.off = Array.prototype.off =
    function (t) {
      this.forEach((e) => {
        e.namespaces &&
          t.split(" ").forEach((t) => {
            e.removeEventListener(t.split(".")[0], e.namespaces[t]),
              delete e.namespaces[t];
          });
      });
    }),
  (NodeList.prototype.not = Array.prototype.not =
    function (e) {
      const i = [];
      return (
        e instanceof HTMLElement && (e = [e]),
        this.forEach((t) => {
          [...e].includes(t) || i.push(t);
        }),
        i
      );
    });
class MediaQueries {
  static medium_screen = 768;
  static large_screen = 1024;
  static current_window = null;
  static init() {
    MediaQueries.updateScreenSize(),
      new ResizeObserver(() => MediaQueries.updateScreenSize()).observe(
        document.body
      );
  }
  static updateScreenSize() {
    var t = MediaQueries.current_window;
    window.matchMedia(
      `only screen and (min-width: ${MediaQueries.medium_screen}px)`
    ).matches
      ? (MediaQueries.current_window = "medium")
      : window.matchMedia(
          `only screen and (min-width: ${MediaQueries.large_screen}px)`
        ).matches
      ? (MediaQueries.current_window = "large")
      : (MediaQueries.current_window = "small"),
      MediaQueries.current_window !== t && window.trigger("theme:mqs:updated");
  }
}
class Utils {
  static disable_prevent_scroll = !1;
  static disable_swipe_listener = !1;
  static scripts = {};
  static links = {};
  static areNumericStrings(...t) {
    return t.every((t) => /^[0-9]+$/.test(t));
  }
  static isValidEmail(t) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(t);
  }
  static scriptLoader(t, e, i) {
    var s;
    void 0 === this.scripts[t]
      ? ((this.scripts[t] = "requested"),
        ((s = document.createElement("script")).src = e),
        (s.onload = () => {
          (this.scripts[t] = "loaded"),
            i && i(),
            window.trigger(`theme:${t}:loaded`);
        }),
        (document.body || document.head).appendChild(s))
      : i && "requested" === this.scripts[t]
      ? window.on(`theme:${t}:loaded`, i)
      : i && "loaded" === this.scripts[t] && i();
  }
  static linkLoader(t, e, i, s) {
    var r;
    this.links[t] ||
      (((r = document.createElement("link")).rel = e),
      (r.href = t),
      s && (r.as = s),
      i && (r.fetchPriority = i),
      document.head.appendChild(r),
      (this.links[t] = r));
  }
  static getFocusableEl(e = !1) {
    if (e) {
      let t = "";
      "small" === MediaQueries.current_window
        ? (t =
            ":not([data-mq='medium-large']):not([data-mq='medium']):not([data-mq='large'])")
        : "medium" === MediaQueries.current_window
        ? (t = ":not([data-mq='small']):not([data-mq='large'])")
        : "large" === MediaQueries.current_window &&
          (t =
            ":not([data-mq='small-medium']):not([data-mq='small']):not([data-mq='medium'])");
      var i = `
            button:not([disabled]):not([aria-hidden='true']),
            [href]:not(link)${t},
            input:not([type='hidden']):not([disabled]):not([aria-hidden='true']),
            select:not([disabled]):not([data-mq='none']):not([aria-hidden='true']),
            textarea:not([disabled]),
            [tabindex]:not([tabindex='-1'])${t}
        `;
      return e.querySelectorAll(i);
    }
  }
  static getQuantity(t, { id: e, management: i, policy: s, quantity: r }, o) {
    if ("shopify" !== i || "continue" === s) return o;
    var a = Cart.basket[e] || 0;
    let n = parseInt(r) - a;
    if (n <= 0) (n = 0), window.trigger(`theme:product:${t}:updateQuantity`, 1);
    else {
      if (!(o > n)) return o;
      window.trigger(`theme:product:${t}:updateQuantity`, n);
    }
    return FeedbackBar.trigger("quantity", n), !1;
  }
  static updateRecentProducts(t) {
    var e = Shopify.theme.name + ":recent_products",
      i = [t],
      s = localStorage.getItem(e);
    let r,
      o,
      a = !1;
    s
      ? -1 === (r = JSON.parse(s)).indexOf(t) && (a = !0)
      : ((o = JSON.stringify(i)), localStorage.setItem(e, o)),
      a &&
        (4 === r.length && (r = r.slice(1)),
        (o = JSON.stringify(r.concat(i))),
        localStorage.setItem(e, o));
  }
}
class Transitions {
  static instances = [];
  static load(t = !1) {
    var e, i;
    t
      ? ((e = t.getAttribute("data-transition-container")),
        (Transitions.instances[e] = new Transitions(t)))
      : ((i = [...document.querySelectorAll("[data-transition-container]")]),
        (Transitions.instances = i.map((t) => new Transitions(t))));
  }
  static reload(e) {
    Transitions.instances.forEach((t) => e === t.name && t.initItems());
  }
  static reset(e) {
    Transitions.instances.forEach((t) => {
      e === t.name &&
        t.items.forEach((t) => t.setAttribute("data-transition-active", !1));
    });
  }
  constructor(t) {
    (this.container = t),
      (this.name = this.container.getAttribute("data-transition-container")),
      "" !== this.name && (this.initItems(), this.itemsListener());
  }
  initItems() {
    (this.cascade = this.container.getAttribute("data-transition-cascade")),
      "horizontal" === this.cascade && (this.column_counter = 0),
      (this.interval = parseInt(
        this.container.getAttribute("data-transition-cascade-interval")
      )),
      (this.reset =
        null !== this.container.getAttribute("data-transition-reset")),
      (this.trigger = this.container.getAttribute("data-transition-trigger")),
      (this.items = this.findItems()),
      this.items.forEach((t, e) => this.configureItem(t, e));
  }
  findItems() {
    return [
      ...document.querySelectorAll(`[data-transition-item="${this.name}"]`),
    ].filter(
      (t) =>
        !(
          ("small" === MediaQueries.current_window &&
            "medium-large" === t.dataset.mq) ||
          ("small" !== MediaQueries.current_window && "small" === t.dataset.mq)
        )
    );
  }
  configureItem(t, e) {
    var i,
      s = t.getAttribute("data-transition-cascade"),
      r = s || this.cascade,
      o = t.getAttribute("data-transition-cascade-interval"),
      a = o ? parseInt(o) : this.interval,
      n = t.getAttribute("data-transition-trigger"),
      l = n || this.trigger;
    r && this.addItemCascade(e, r, a),
      (null !== l && isNaN(parseInt(l))) ||
        ((i =
          null !== this.items[e].getAttribute("data-transition-reset") ||
          this.reset),
        this.addItemObserver(e, i, null === l ? 0.4 : parseInt(l) / 100));
  }
  addItemCascade(t, e, i) {
    var s,
      r,
      o =
        null !== this.items[t].getAttribute("data-transition-cropper")
          ? this.items[t].children[0]
          : this.items[t];
    "horizontal" === e
      ? ((s = this.items[t].offsetTop),
        (r = 0 < t ? this.items[t - 1].offsetTop : s),
        (this.column_counter = 0 < t && s === r ? this.column_counter + 1 : 0),
        (o.style.transitionDelay = this.column_counter * i + "ms"))
      : "vertical" === e && (o.style.transitionDelay = t * i + "ms");
  }
  addItemObserver(t, i, e) {
    new IntersectionObserver(
      ([{ target: t, isIntersecting: e }]) => {
        e && "vertical" === this.cascade
          ? this.items.forEach((t) => {
              t.setAttribute("data-transition-active", !0),
                t.on(
                  "transitionend",
                  () => t.setAttribute("data-transition-finished", !0),
                  { once: !0 }
                );
            })
          : e
          ? (t.setAttribute("data-transition-active", !0),
            t.on(
              "transitionend",
              () => t.setAttribute("data-transition-finished", !0),
              { once: !0 }
            ))
          : i &&
            (t.setAttribute("data-transition-active", !1),
            t.on(
              "transitionend",
              () => t.setAttribute("data-transition-finished", !1),
              { once: !0 }
            ));
      },
      { threshold: e }
    ).observe(this.items[t]);
  }
  itemsListener() {
    window.on("theme:mqs:updated", () => this.initItems());
  }
}
class Drawer extends HTMLElement {
  static instance = null;
  static status = "closed";
  static disable_swipe_listener = !1;
  constructor() {
    super();
  }
  connectedCallback() {
    ((Drawer.instance = this).close_button = document.querySelector(
      ".layout--navigation > .layout--close"
    )),
      (this.focus_start = this.querySelector(".drawer--focus-start")),
      (this.focus_triggers = this.querySelectorAll(".drawer--focus-trigger")),
      (this.main_content = this.previousElementSibling),
      (this.overlay = this.querySelector(".drawer--overlay")),
      (this.viewport = this.parentElement),
      (this.state = {}),
      this.load();
  }
  load() {
    this.viewportObserver(), this.loadTriggers(), this.touchListener();
  }
  viewportObserver() {
    window.on("resize", () => this.setViewport());
  }
  setViewport() {
    this.viewport.style.minHeight = window.innerHeight + "px";
  }
  loadTriggers() {
    (this.close_triggers = document.querySelectorAll("[data-drawer-close]")),
      (this.open_triggers = document.querySelectorAll("[data-drawer-open]")),
      this.closeListeners(),
      this.toggleListeners();
  }
  closeListeners() {
    this.focus_triggers.off("focus"),
      this.focus_triggers.on("focus", () => this.close()),
      window.off("keydown.Drawer"),
      window.on("keydown.Drawer", (t) => {
        "Escape" === t.key && "closed" !== Drawer.status && this.close();
      }),
      [...this.close_triggers, this.overlay].off("click.Drawer keydown.Drawer"),
      [...this.close_triggers, this.overlay].on(
        "click.Drawer keydown.Drawer",
        ({ key: t, type: e }) => {
          ("keydown" === e && "Enter" !== t) || this.close();
        }
      );
  }
  toggleListeners() {
    this.open_triggers.off("click.Drawer keydown.Drawer"),
      this.open_triggers.on("click.Drawer keydown.Drawer", (t) => {
        var e, i;
        ("keydown" === t.type && "Enter" !== t.key) ||
          ((e = t.target.getAttribute("data-drawer-open")),
          (i = t.target.getAttribute("data-drawer-view")),
          this.open(e, i, t.target),
          t.preventDefault(),
          t.stopPropagation());
      });
  }
  toggle(t) {
    (Drawer.status = t),
      this.viewport.setAttribute("data-drawer-status", t),
      "opening" === t
        ? this.opening()
        : "closing" === t
        ? this.closing()
        : "opened" === t
        ? this.opened()
        : "closed" === t && this.closed(),
      window.trigger(`theme:drawer:${this.state.side}:` + t);
  }
  open(t, e, i) {
    this.setViewport(),
      Drawer.status.includes("open") && t != this.state.side
        ? ((this.pending_open = [t, e, i]), this.close())
        : ((this.pending_open = null),
          (this.state = {
            active: this.querySelector(`.drawer--side[data-side=${t}]`),
            side: t,
            trigger: i,
            view: e,
          }),
          this.viewport.setAttribute("data-drawer-view", e),
          this.viewport.setAttribute("data-drawer-side", t),
          "opened" != Drawer.status && this.toggle("opening"));
  }
  opening() {
    this.overlay.setAttribute("aria-hidden", !1),
      (this.window_offset = window.scrollY),
      this.main_content.setStyles({
        top: 0 === this.window_offset ? "0px" : `-${this.window_offset}px`,
        position: "fixed",
      }),
      this.state.active.setAttribute("aria-expanded", !0),
      window.scrollTo(0, 0),
      "top" !== this.state.side && this.toggleCloseButton(!0),
      this.state.active.on("transitionend", () => this.toggle("opened"), {
        once: !0,
      });
  }
  opened() {
    var t = document.getElementById(
      this.state.active.getAttribute("data-focus-id")
    );
    (t || this.focus_start).focus();
  }
  close() {
    Drawer.status.includes("clos") || this.toggle("closing");
  }
  closing() {
    this.overlay.setAttribute("aria-hidden", !0),
      "top" !== this.state.side && this.toggleCloseButton(!1),
      this.state.active.setAttribute("aria-expanded", !1),
      this.state.active.on("transitionend", () => this.toggle("closed"), {
        once: !0,
      }),
      this.state.trigger && this.state.trigger.focus(),
      Transitions.reset(this.state.view);
  }
  closed() {
    this.viewport.removeAttribute("data-drawer-view"),
      this.viewport.removeAttribute("data-drawer-side"),
      this.main_content.removeAttribute("style"),
      window.scrollTo(0, this.window_offset),
      this.pending_open && this.open(...this.pending_open);
  }
  toggleCloseButton(t) {
    this.close_button.setAttribute("aria-hidden", !t),
      t
        ? this.close_button.on(
            "click.Drawer keydown.Drawer",
            ({ key: t, type: e }) => {
              ("keydown" === e && "Enter" !== t) || this.close();
            }
          )
        : this.close_button.off("click.Drawer keydown.Drawer");
  }
  touchListener() {
    window.matchMedia("(pointer: coarse)").matches &&
      (window.on("theme:swipe:left", () => {
        Drawer.disable_swipe_listener ||
          "left" !== this.state.side ||
          "opened" != Drawer.status ||
          this.close();
      }),
      window.on("theme:swipe:right", ({}) => {
        Drawer.disable_swipe_listener ||
          "right" !== this.state.side ||
          "opened" != Drawer.status ||
          this.close();
      }));
  }
  static open(t, e, i) {
    Drawer.instance && Drawer.instance.open(t, e, i);
  }
  static close() {
    Drawer.instance && Drawer.instance.close();
  }
  static loadTriggers() {
    Drawer.instance && Drawer.instance.loadTriggers();
  }
}
customElements.define("drawer-element", Drawer);
class Cart extends HTMLElement {
  static instances = [];
  static basket = {};
  constructor() {
    super();
  }
  connectedCallback() {
    Cart.instances.push(this),
      (this.abort_controllers = {}),
      (this.checkout_button = this.querySelector(".cart--checkout-button")),
      (this.dynamic_checkout_buttons = this.querySelector(
        ".cart--additional-buttons"
      )),
      (this.note = this.querySelector(".cart--notes--textarea")),
      this.toggleLoadingOnSubmit(),
      this.note && this.noteTypingListener(),
      this.dynamic_checkout_buttons && this.renderDynamicCheckoutButtons();
  }
  toggleLoadingOnSubmit() {
    this.checkout_button.on("click", () =>
      this.checkout_button.setAttribute("data-loading", !0)
    );
  }
  noteTypingListener() {
    this.note.on("input", () => {
      this.updateNote(this.note.value),
        Cart.instances
          .not(this)
          .forEach((t) => (t.note.value = this.note.value));
    });
  }
  async updateNote(t) {
    this.abort_controllers.note && this.abort_controllers.note.abort(),
      (this.abort_controllers.note = new AbortController());
    try {
      await fetch(Shopify.routes.cart_update + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: t }),
        signal: this.abort_controllers.note.signal,
      });
    } catch {}
  }
  renderDynamicCheckoutButtons() {
    var t, e;
    window.location.pathname === Shopify.routes.cart &&
      ((t = document.querySelector(
        ".drawer--root .cart--additional-buttons"
      )) && t.remove(),
      "small" === MediaQueries.current_window) &&
      (e = document.querySelector(
        '.drawer--root [data-view="desktop"] .cart--additional-buttons'
      )) &&
      e.remove();
  }
  toggleLoadingDisplay(t, e) {
    var i;
    !t &&
      e &&
      (i = this.querySelector(`.cart--item[data-line-num='${e}'] input`)) &&
      i.setAttribute("data-loading", !0),
      t
        ? this.checkout_button.removeAttribute("disabled")
        : this.checkout_button.setAttribute("disabled", "disabled"),
      this.dynamic_checkout_buttons &&
        this.dynamic_checkout_buttons.setAttribute("data-disabled", !t);
  }
  async tryToUpdateQuantity(t, e) {
    this.toggleLoadingDisplay(!1, t);
    try {
      var i = await this.updateQuantity(t, e);
      await Cart.updateAllHtml(), i || 0 === e || this.showQuantityError(t);
    } catch {}
  }
  showQuantityError(t) {
    var e = this.querySelector(`.cart--item[data-line-num='${t}']`);
    e && e.querySelector(".cart--error").removeAttribute("style");
  }
  async updateQuantity(t, e) {
    this.abort_controllers.line_num && this.abort_controllers.line_num.abort(),
      (this.abort_controllers.line_num = new AbortController());
    var {
        management: i,
        policy: s,
        quantity: r,
      } = this.querySelector(`.cart--item[data-line-num='${t}']`).dataset,
      o = e > parseInt(r) && "shopify" === i && "continue" !== s;
    o && (e = parseInt(r));
    try {
      var a = await fetch(Shopify.routes.cart_change + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: t, quantity: e }),
        signal: this.abort_controllers.line_num.signal,
      });
      if (a.ok) return Cart.fetchTotals(), !o;
      throw new Error(a.statusText);
    } catch {
      throw new Error("aborted");
    }
  }
  static updateAllHtml(e) {
    var t = Cart.instances.map((t) => t.updateHtml(e));
    return Promise.allSettled(t);
  }
  async updateHtml(t) {
    var e,
      i = await fetch(Shopify.routes.cart + "?view=ajax-" + this.dataset.view);
    if (i.ok)
      return (
        (e = (await i.text()).parse(".cart--form")),
        this.swapInNewContent(e),
        this.toggleLoadingDisplay(!0),
        Transitions.reload("cart-" + this.dataset.view),
        t && Transitions.reset("cart-" + this.dataset.view),
        window.trigger("theme:cart:updated", this),
        !0
      );
    throw new Error(i.statusText);
  }
  swapInNewContent(t) {
    var e = this.querySelector(".cart--body"),
      i = t.querySelector(".cart--body"),
      s = this.querySelector(".cart--shipping"),
      r = t.querySelector(".cart--shipping"),
      o =
        (s && r && s.replaceWith(r),
        (i = this.swapInImages(e, i)),
        e && i && e.replaceWith(i),
        this.querySelector(".cart--total--price")),
      a = t.querySelector(".cart--total--price");
    o && a && o.replaceWith(a);
  }
  swapInImages(s, t) {
    var e = t.querySelectorAll(".cart--item");
    return (
      0 !== e.length &&
      (e.forEach((t) => {
        var e = t.querySelector(".cart--item--image"),
          i = s.querySelector(
            `[data-variant-id='${t.getAttribute(
              "data-variant-id"
            )}'] .cart--item--image`
          );
        i && e && e.replaceWith(i);
      }),
      t)
    );
  }
  static async addItems(t = {}, ...e) {
    var i = await fetch(Shopify.routes.cart_add + ".js", t);
    if (!i.ok) throw new Error(i.statusText);
    Cart.fetchTotals(),
      await Cart.updateAllHtml(!0),
      e.forEach((t) => window.trigger("theme:cart:productAdded", t));
  }
  static async fetchTotals(t = !1) {
    var e = await fetch(Shopify.routes.cart + ".js");
    if (!e.ok) throw new Error(e.statusText);
    var { items: i, item_count: s } = await e.json();
    Cart.fillBasket(i), t || Cart.updateTotals(s);
  }
  static fillBasket(t) {
    (Cart.basket = {}),
      t.forEach(({ id: t, quantity: e }) => (Cart.basket[t] = e));
  }
  static updateTotals(i) {
    document
      .querySelector("[data-cart-count]")
      .setAttribute("data-cart-count", i),
      Cart.instances.forEach((t, e) => {
        t.setAttribute("data-has-items", 0 < i),
          0 === i && ((t.note.value = ""), 0 === e) && t.updateNote("");
      });
  }
}
customElements.define("cart-element", Cart);
class Modal extends HTMLElement {
  static instances = {};
  static status = "closed";
  static viewport = document.querySelector(".layout--viewport");
  static close_button = document.querySelector(
    ".layout--navigation > .layout--close"
  );
  static next_button = document.querySelector(".layout--next");
  static previous_button = document.querySelector(".layout--previous");
  constructor() {
    super(),
      ((Modal.instances[this.dataset.id] = this).blocking =
        null !== this.dataset.blocking && this.dataset.blocking),
      this.blocking &&
        (this.local_storage_name = Shopify.theme.name + ":" + this.blocking),
      (this.close_buttons = this.querySelectorAll("[data-modal-close]")),
      (this.focus_triggers = this.querySelectorAll(".modal--focus-trigger")),
      (this.next_buttons = this.querySelectorAll('[data-modal-button="next"]')),
      (this.previous_buttons = this.querySelectorAll(
        '[data-modal-button="previous"]'
      )),
      (this.views = this.querySelectorAll(".modal--view")),
      (this.trigger = document.querySelector("#a11y_skip")),
      (this.state = {
        active_index: 0,
        previous_index: this.views.length - 1,
        active_view: this.views[0],
        previous_view: this.views[this.views.length - 1],
        view_disabled: !1,
      });
  }
  connectedCallback() {
    !this.blocking ||
      Shopify.designMode ||
      (window.localStorage &&
        void 0 !== localStorage[this.local_storage_name]) ||
      this.open();
  }
  disconnectedCallback() {
    this.close();
  }
  updateStatus(t) {
    (Modal.status = t), Modal.viewport.setAttribute("data-modal-status", t);
  }
  open(t) {
    "opened" !== Modal.status &&
      (t && (this.trigger = t),
      (this.window_offset = window.scrollY),
      Modal.viewport.setStyles({
        top: 0 === this.window_offset ? "0px" : `-${this.window_offset}px`,
        position: "fixed",
      }),
      Modal.viewport.setAttribute("data-modal-view", this.dataset.id),
      this.setAttribute("aria-hidden", !1),
      this.updateStatus("opened"),
      setTimeout(() => {
        this.on("transitionend", () => this.opened(), { once: !0 }),
          this.setAttribute("data-transition-active", !0),
          this.blocking || Modal.toggleButtons(!0, 1 < this.views.length);
      }, 0),
      this.addListeners());
  }
  opened() {
    var t = document.getElementById(this.getAttribute("data-focus-id"));
    (t || Modal.close_button).focus();
  }
  addListeners() {
    (this.next_buttons.length ? this.next_buttons : Modal.next_button).on(
      `click.${this.dataset.id}-modal`,
      () => this.toggleView("next")
    ),
      (this.close_buttons.length ? this.close_buttons : Modal.close_button).on(
        `click.${this.dataset.id}-modal`,
        () => this.close()
      ),
      (this.previous_buttons.length
        ? this.previous_buttons
        : Modal.previous_button
      ).on(`click.${this.dataset.id}-modal`, () => this.toggleView("previous")),
      this.blocking ||
        (window.on(`keydown.${this.dataset.id}-modal`, ({ key: t }) => {
          var e = 1 < this.views.length && !this.blocking;
          "Escape" === t
            ? this.close()
            : "ArrowLeft" === t
            ? e && this.toggleView("previous")
            : "ArrowRight" === t && e && this.toggleView("next");
        }),
        this.on(
          `click.${this.dataset.id}-modal`,
          ({ target: t }) => t === this && this.close()
        ),
        this.focus_triggers.length &&
          this.focus_triggers.on(`focus.${this.dataset.id}-modal`, () =>
            this.close()
          ));
  }
  close() {
    "closed" === Modal.status ||
      this.state.view_disabled ||
      (Modal.viewport.removeAttribute("style"),
      this.on("transitionend", () => this.closed(), { once: !0 }),
      !Shopify.designMode && this.trigger && this.trigger.focus(),
      window.scrollTo(0, this.window_offset),
      this.setAttribute("data-transition-type", "fade-out"),
      this.updateStatus("closed"),
      this.blocking
        ? (localStorage[this.local_storage_name] = "true")
        : Modal.toggleButtons(!1),
      this.removeListeners());
  }
  closed() {
    this.setAttribute("data-transition-type", "fade-in"),
      this.setAttribute("data-transition-active", !1),
      this.setAttribute("aria-hidden", !0);
  }
  removeListeners() {
    var t = this.next_buttons.length ? this.next_buttons : Modal.next_button,
      e = this.close_buttons.length ? this.close_buttons : Modal.close_button;
    [
      t,
      this.previous_buttons.length
        ? this.previous_buttons
        : Modal.previous_button,
      e,
    ].off(`click.${this.dataset.id}-modal`),
      this.blocking ||
        (window.off(`keydown.${this.dataset.id}-modal`),
        this.off(`click.${this.dataset.id}-modal`),
        this.focus_triggers.length &&
          this.focus_triggers.off(`focus.${this.dataset.id}-modal`));
  }
  toggleView(e) {
    if (!this.state.view_disabled) {
      let t = !0;
      "next" === e
        ? this.updateView(this.state.active_index + 1, !0)
        : "previous" === e
        ? this.updateView(this.state.active_index - 1)
        : isNaN(e) || (this.updateView(e, !0), (t = !1)),
        t
          ? (this.state.previous_view.on(
              "transitionend",
              () => {
                this.state.active_view.setAttribute(
                  "data-transition-active",
                  !0
                ),
                  this.state.previous_view.setAttribute(
                    "data-transition-type",
                    "fade-in"
                  ),
                  this.state.previous_view.setAttribute(
                    "data-transition-active",
                    !1
                  );
              },
              { once: !0 }
            ),
            this.state.active_view.on(
              "transitionend",
              () => {
                this.state.active_view.setAttribute(
                  "data-transition-type",
                  "fade-out"
                ),
                  this.state.active_view.setAttribute(
                    "data-transition-active",
                    !1
                  ),
                  (this.state.view_disabled = !1);
              },
              { once: !0 }
            ),
            (this.state.view_disabled = !0),
            this.state.previous_view.setAttribute("data-transition-active", !0))
          : this.views.forEach((t) => {
              var e = t === this.state.active_view;
              t.setAttribute(
                "data-transition-type",
                e ? "fade-out" : "fade-in"
              ),
                t.setAttribute("data-transition-active", !1);
            });
    }
  }
  updateView(t, e) {
    t > this.views.length - 1
      ? ((this.state.active_index = 0),
        (this.state.previous_index = this.views.length - 1))
      : t < 0
      ? ((this.state.previous_index = 0),
        (this.state.active_index = this.views.length - 1))
      : ((this.state.previous_index =
          0 === t ? (e ? this.views.length - 1 : 1) : this.state.active_index),
        (this.state.active_index = t)),
      (this.state.active_view = this.views[this.state.active_index]),
      (this.state.previous_view = this.views[this.state.previous_index]);
  }
  static toggleButtons(t, e = !1) {
    Modal.close_button.setAttribute("aria-hidden", !t),
      [Modal.previous_button, Modal.next_button].forEach((t) =>
        t.setAttribute("aria-hidden", !e)
      );
  }
}
customElements.define("modal-element", Modal);
class ModalTrigger extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const i = parseInt(this.getAttribute("data-delay")),
      s = parseInt(this.getAttribute("data-index"));
    this.on(
      `click.${this.dataset.id}-modal-trigger keydown.${this.dataset.id}-modal-trigger`,
      (t) => {
        const e = Modal.instances[this.dataset.id];
        ("keydown" === t.type && "Enter" !== t.key) ||
          (isNaN(s) || e.toggleView(s, !1),
          "closed" !== Drawer.status && Drawer.close(),
          isNaN(i) ? e.open(this) : setTimeout(() => e.open(this), i));
      }
    );
  }
  disconnectedCallback() {
    this.off(
      `click.${this.dataset.id}-modal-trigger keydown.${this.dataset.id}-modal-trigger`
    );
  }
}
customElements.define("modal-trigger", ModalTrigger);
class FeedbackBar extends HTMLElement {
  static instance = null;
  constructor() {
    super();
  }
  connectedCallback() {
    ((FeedbackBar.instance = this).message_container = this.querySelector(
      ".feedback-bar--message"
    )),
      (this.message_json = JSON.parse(
        this.querySelector("script").textContent
      )),
      this.load();
  }
  load(t = !1) {
    var e = window.location.hash.substring(1),
      i = t || e.replace("feedback-bar--", "");
    this.message_json[i] &&
      ((this.message_container.textContent = this.message_json[i]),
      this.open());
  }
  open() {
    this.setAttribute("aria-hidden", !1),
      setTimeout(() => this.setAttribute("data-transition-active", !0), 5),
      this.timeout && clearTimeout(this.timeout),
      (this.timeout = setTimeout(() => this.close(), 5e3));
  }
  close() {
    this.setAttribute("data-transition-active", !1),
      this.on("transitionend", () => this.setAttribute("aria-hidden", !0), {
        once: !0,
      });
  }
  trigger(t, e) {
    "copy" === t
      ? (navigator.clipboard.writeText(window.location.href),
        this.load("copied"))
      : "quantity" === t && this.loadProductQuantity(e);
  }
  loadProductQuantity(t) {
    var e;
    0 === t
      ? this.load("product--no-items")
      : 1 === t
      ? this.load("product--one-item")
      : 1 < t &&
        ((e = this.message_json["product--n-items"].replace("[num_items]", t)),
        (this.message_json[`product--${t}-items`] = e),
        this.load(`product--${t}-items`));
  }
  static trigger(t, e) {
    FeedbackBar.instance && FeedbackBar.instance.trigger(t, e);
  }
  static load(t = !1) {
    FeedbackBar.instance && FeedbackBar.instance.load(t);
  }
}
customElements.define("feedback-bar-element", FeedbackBar);
class QuickAdd extends HTMLElement {
  static forms = {};
  constructor() {
    super();
  }
  connectedCallback() {
    (this.button = this.querySelector(".product--quick-add--button")),
      (this.handle = this.dataset.handle),
      (this.query =
        "?section_id=product--quick-add--form&variant=" + this.dataset.id),
      this.button.on("click", async (t) => {
        t.preventDefault(),
          this.setAttribute("aria-busy", !0),
          "true" === this.dataset.form
            ? await this.showForm()
            : await this.addToCart(),
          this.setAttribute("aria-busy", !1);
      });
  }
  disconnectedCallback() {
    this.button.off("click");
  }
  async showForm() {
    let e = !0;
    if (
      (Object.keys(QuickAdd.forms).forEach((t) => {
        (QuickAdd.forms[t].style.display =
          t === this.handle ? "block" : "none"),
          t === this.handle && (e = !1);
      }),
      e)
    ) {
      var t = await fetch(
        `${Shopify.routes.root}products/${this.handle}/` + this.query
      );
      if (!t.ok)
        throw (this.setAttribute("data-loading", !1), new Error(t.status));
      var i = (await t.text()).parse(".product--quick-add--form");
      (QuickAdd.forms[this.handle] = i),
        document
          .querySelector('.drawer--container[data-view="product-form"]')
          .appendChild(i);
    }
    Utils.updateRecentProducts(this.handle),
      Drawer.open("right", "product-form", this);
  }
  async addToCart() {
    if (Utils.getQuantity(this.dataset.id, this.dataset, 1)) {
      var t = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: this.dataset.id, quantity: 1 }] }),
      };
      try {
        await Cart.addItems(t, this.dataset.id),
          Drawer.open("right", "cart-drawer", this.button);
      } catch (t) {
        throw (this.setAttribute("data-loading", !1), new Error(t));
      }
    }
  }
  static clearFormListeners() {
    window.on("theme:navigation:reloaded theme:search:reloaded", () => {
      Object.keys(QuickAdd.forms).forEach((t) => QuickAdd.forms[t].remove()),
        (QuickAdd.forms = {});
    });
  }
}
customElements.define("product-quick-add", QuickAdd);
class Popup extends HTMLElement {
  static instances = [];
  static parent = document.querySelector(".popup--root");
  static options = {
    size: parseInt(Popup.parent && Popup.parent.getAttribute("data-size")),
    limit: Popup.parent && "true" === Popup.parent.getAttribute("data-limit"),
    consent_tracking:
      Popup.parent &&
      "true" === Popup.parent.getAttribute("data-consent-tracking"),
  };
  constructor() {
    super();
  }
  connectedCallback() {
    Popup.instances.unshift(this),
      (this.container = this.querySelector(".popup--block--container")),
      (this.close_link = this.querySelector(".layout--close")),
      (this.delay = parseInt(1e3 * this.getAttribute("data-delay"))),
      (this.referrer_enabled =
        "true" === this.getAttribute("data-referrer-enabled")),
      (this.referrer_url = this.getAttribute("data-referrer-url")),
      (this.show_again_after = parseInt(
        this.getAttribute("data-show-again-after")
      )),
      (this.show_at_bottom =
        "true" === this.getAttribute("data-show-at-bottom"));
    var t = this.getAttribute("data-block-id");
    (this.id = Shopify.theme.name + ":popup:" + t),
      this.eventListeners(),
      Popup.options.consent_tracking ||
        Popup.options.size !== Popup.instances.length ||
        Popup.loadNext();
  }
  load() {
    (!this.referrer_enabled || document.referrer.includes(this.referrer_url)) &&
    (void 0 === localStorage[this.id] || this.readyToReset())
      ? (this.setResetTime(), this.startTimer())
      : (Popup.loadNext(), Shopify.designMode || this.remove());
  }
  startTimer() {
    Popup.options.limit && Popup.removeAll(),
      (this.timer = setTimeout(
        () => !Shopify.designMode && this.open(),
        this.delay
      )),
      this.show_at_bottom && this.addObserver();
  }
  addObserver() {
    var t = document.querySelector(".layout--main-content").lastElementChild;
    t &&
      ((this.observer = new IntersectionObserver(
        ([{ isIntersecting: t }], e) => {
          t &&
            (Shopify.designMode || this.open(),
            clearTimeout(this.timer),
            e.disconnect());
        },
        { threshold: 0.1 }
      )),
      this.observer.observe(t));
  }
  eventListeners() {
    this.close_link.on("click", () => {
      this.close(),
        this.observer && this.observer.disconnect(),
        Popup.loadNext();
    });
  }
  open() {
    this.setAttribute("aria-hidden", !1),
      setTimeout(() => this.setAttribute("data-transition-active", !0), 5);
  }
  close() {
    this.setAttribute("data-transition-active", !1),
      this.on("transitionend", () => !Shopify.designMode && this.remove(), {
        once: !0,
      });
  }
  readyToReset() {
    var t = JSON.parse(localStorage[this.id]).expires,
      e = new Date().getTime();
    return parseFloat(t - e) <= 0 && (this.setResetTime(), !0);
  }
  setResetTime() {
    var t = new Date(),
      e = 864e5 * this.show_again_after,
      i = t.setTime(t.getTime() + e);
    localStorage[this.id] = JSON.stringify({ expires: i });
  }
  static loadNext() {
    0 < Popup.instances.length && Popup.instances.pop().load();
  }
  static removeAll() {
    Popup.instances.forEach((t) => !Shopify.designMode && t.remove()),
      (Popup.instances = []);
  }
}
customElements.define("popup-block", Popup);
class TabOrder {
  constructor(t = !1, e = !1) {
    (this.mobile_order_elements = this.getElementList(t)),
      (this.desktop_order_elements = this.getElementList(e)),
      (this.tabbing = !1),
      this.detectTabbing(),
      this.updateOrderList(),
      this.focusListener(),
      this.resizeListener();
  }
  detectTabbing() {
    window.off("click.TabOrder, keydown.TabOrder"),
      window.on("click.TabOrder", () => (this.tabbing = !1)),
      window.on("keydown.TabOrder", (t) => {
        9 === t.which && (this.tabbing = !0);
      }),
      document.on("keydown", (t) => {
        (this.tab_forwards = !0),
          "Tab" === t.key && t.shiftKey && (this.tab_forwards = !1);
      });
  }
  getElementList(t) {
    if (t) {
      const i = [];
      return (
        t.forEach((t) => {
          var e = document.querySelectorAll(t);
          e.length && e.forEach((t) => i.push(t));
        }),
        i
      );
    }
    return !1;
  }
  updateOrderList() {
    "small" === MediaQueries.current_window
      ? ((this.current_order_elements = this.mobile_order_elements),
        (this.previous_order_elements = this.desktop_order_elements))
      : ((this.current_order_elements = this.desktop_order_elements),
        (this.previous_order_elements = this.mobile_order_elements));
  }
  focusListener() {
    this.current_order_elements &&
      this.current_order_elements.on("focusout", (t) =>
        this.focusOutCallback(t.target, t.target.index(), t)
      );
  }
  focusOutCallback(t, e, i) {
    var s;
    this.tabbing &&
      ((s = !t.contains(i.relatedTarget) && "closed" === Drawer.status) &&
      this.tab_forwards
        ? this.moveFocus(e + 1, "forwards")
        : s && this.moveFocus(e - 1, "backwards"));
  }
  moveFocus(t, e) {
    var i = this.current_order_elements[t],
      s = Utils.getFocusableEl(i);
    t < this.current_order_elements.length &&
      "forwards" === e &&
      (s
        ? s[0].focus()
        : t + 1 < this.current_order_elements.length &&
          this.moveFocus(t + 1, "forwards")),
      0 <= t &&
        "backwards" === e &&
        (s
          ? s[s.length - 1].focus()
          : 0 <= t - 1 && this.moveFocus(t - 1, "backwards"));
  }
  disableFocus() {
    this.previous_order_elements &&
      this.previous_order_elements.off("focusout");
  }
  resizeListener() {
    window.on("theme:mqs:updated", () => {
      this.updateOrderList(), this.focusListener(), this.disableFocus();
    });
  }
}
class Carousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.blocks = this.querySelectorAll(".carousel--block")),
      (this.container = this.querySelector(".carousel--container")),
      (this.dot_nav = this.querySelector(".carousel--dot-nav")),
      (this.links = this.container && this.container.querySelectorAll("a")),
      (this.next = this.querySelector(".carousel--next")),
      (this.prev = this.querySelector(".carousel--prev")),
      (this.auto_rotate = "true" === this.getAttribute("data-auto-rotate")),
      (this.blocks_per_slide_desktop = parseInt(
        this.getAttribute("data-blocks-per-slide")
      )),
      (this.blocks_per_slide_mobile = parseInt(
        this.getAttribute("data-mobile-blocks-per-slide")
      )),
      (this.dot_nav_enabled = "true" === this.getAttribute("data-dot-nav")),
      (this.rotate_frequency = parseInt(
        this.getAttribute("data-rotate-frequency")
      )),
      (this.section_id =
        this.closest("[data-section-id]").getAttribute("data-section-id")),
      (this.total_blocks = this.blocks.length),
      (this.transition_type = this.getAttribute("data-transition-type")),
      (this.active_slide = 1),
      (this.autoplay_focus_enabled = !1),
      (this.dot_offset = 0),
      (this.dot_width = 20),
      (this.slide_pause = !1),
      (this.container_destination = "0px"),
      (this.trailing_dot_index = 0),
      (this.leading_dot_index = 0),
      (this.dot_nav_offset = 0),
      (this.active_blocks = null),
      (this.auto_slide_timer = null),
      (this.blocks_per_slide = null),
      (this.old_active_blocks = null),
      (this.screen_size_loaded = null),
      (this.slide_count = null),
      (this.swipe_state = null),
      (this.carousel_width = null),
      (this.dot_change_type = null),
      this.load();
  }
  disconnectedCallback() {
    this.auto_rotate &&
      this.auto_slide_timer &&
      clearInterval(this.auto_slide_timer);
  }
  load() {
    this.initNewScreenSize(),
      this.updateActive(),
      this.resizeObservers(),
      this.getAllFocusableEl(),
      this.mouseDownListener(),
      this.swipeListener(),
      this.arrowNavListeners(),
      "slide" === this.transition_type && this.loadBlocks(),
      this.auto_rotate && this.startAutoRotate(),
      Shopify.designMode && (this.blockListener(), this.sectionListener()),
      this.setSliderHeight();
  }
  initNewScreenSize() {
    if ("small" === MediaQueries.current_window) {
      if ("small" === this.screen_size_loaded) return;
      this.dot_nav_enabled && this.dot_nav.setAttribute("data-loaded", !1),
        (this.screen_size_loaded = "small"),
        (this.blocks_per_slide = this.blocks_per_slide_mobile),
        (this.active_slide = Math.ceil(
          (this.blocks_per_slide_desktop * (this.active_slide - 1) + 1) /
            this.blocks_per_slide_mobile
        ));
    } else {
      if ("medium-large" === this.screen_size_loaded) return;
      (this.screen_size_loaded = "medium-large"),
        (this.blocks_per_slide = this.blocks_per_slide_desktop),
        (this.active_slide = Math.ceil(
          (this.blocks_per_slide_mobile * (this.active_slide - 1) + 1) /
            this.blocks_per_slide_desktop
        ));
    }
    (this.dot_change_type = "init"),
      (this.slide_count = Math.ceil(this.total_blocks / this.blocks_per_slide)),
      this.createDotNav(),
      this.goToActiveSlide(),
      this.updateActiveDot();
  }
  getAllFocusableEl() {
    this.focusable_el = Utils.getFocusableEl(this);
  }
  loadBlocks() {
    this.blocks.forEach((t) => {
      t.setAttribute("data-loaded", !0),
        t.setAttribute("data-mobile-loaded", !0);
    });
  }
  blockListener() {
    this.blocks.on("theme:block:select", (t) => {
      var e = Math.ceil((t.target.index() + 1) / this.blocks_per_slide);
      this.updateThenGoToActiveSlide(e, !0),
        this.auto_slide_timer &&
          (this.setAttribute("data-auto-rotate", !1),
          clearInterval(this.auto_slide_timer));
    }),
      this.blocks.on("theme:block:deselect", () => {
        this.auto_rotate &&
          (this.setAttribute("data-auto-rotate", !0), this.startAutoRotate());
      });
  }
  sectionListener() {
    this.closest("[data-section-id]").on(
      "theme:section:load",
      () => (this.style.opacity = 1)
    );
  }
  mouseDownListener() {
    this.container.on(
      "mousedown touchstart",
      (t) => {
        if (!(t.touches && 1 < t.touches.length)) {
          var e,
            i = t.target.closest(".carousel--block");
          if (i && this.checkForActiveModel && this.checkForActiveModel(i))
            return !1;
          (this.swipe_state = "swipe-started"),
            this.reenableClickAfterSwiping(),
            this.mouseUpListener(),
            (this.slide_pause = !0),
            "slide" === this.transition_type &&
              ((this.drag_start = (
                "touchstart" === t.type ? t.targetTouches[0] : t
              ).pageX),
              (e =
                this.container.style.transform.replace(/[^0-9\-.,]/g, "") /
                100),
              (this.current_transform_pixels =
                this.container.offsetWidth * parseFloat(e)),
              this.container.setAttribute("data-transition-state", ""),
              (this.container.style.transform = `translateX(${this.current_transform_pixels}px)`),
              this.dragBegin());
        }
      },
      { passive: !0 }
    );
  }
  mouseUpListener() {
    window.on(
      `mouseup.${this.section_id} touchend.` + this.section_id,
      (t) => {
        (t.touches && 1 < t.touches.length) ||
          ((this.swipe_state = "swipe-ended"),
          this.removeMouseUpListener(),
          this.dragEnd(),
          !0 === this.slide_pause &&
            (this.container.setAttribute("data-transition-state", "forwards"),
            (this.container.style.transform = `translateX(${this.container_destination})`)));
      },
      { passive: !0 }
    );
  }
  removeMouseUpListener() {
    window.off(`mouseup.${this.section_id} touchend.` + this.section_id);
  }
  dragBegin() {
    this.setAttribute("data-dragging", !0),
      (Drawer.disable_swipe_listener = !0),
      window.on(
        `mousemove.${this.section_id} touchmove.` + this.section_id,
        (e) => {
          if (!(e.touches && 1 < e.touches.length)) {
            var i = ("touchmove" === e.type ? e.targetTouches[0] : e).pageX;
            let t = this.current_transform_pixels - this.drag_start + i;
            var s = this.carousel_width * (this.slide_count - 1);
            0 < t
              ? (this.container.style.transform = `translateX(${t / 4}px)`)
              : t < -1 * s
              ? ((t = s + ((t *= -1) - s) / 4),
                (this.container.style.transform = `translateX(-${t}px)`))
              : (this.container.style.transform = `translateX(${t}px)`);
          }
        },
        { passive: !0 }
      );
  }
  dragEnd() {
    this.setAttribute("data-dragging", !1),
      (Drawer.disable_swipe_listener = !1),
      window.off(`mousemove.${this.section_id} touchmove.` + this.section_id);
  }
  updateContainerDestination() {
    (this.container_destination =
      ((this.active_slide - 1) / this.slide_count) * -100 + "%"),
      (this.container.style.transform = `translateX(${this.container_destination})`);
  }
  slideToNext(t = !1, e = !1) {
    this.dot_change_type = "iterate";
    let i;
    return (
      this.active_slide !== this.slide_count
        ? (this.updateActive("next", e), (i = "forwards"))
        : t && this.active_slide === this.slide_count
        ? ((this.active_slide = 1), this.updateActive(!1, e), (i = "forwards"))
        : this.active_slide === this.slide_count && (i = "backwards"),
      this.goToActiveSlide(!0, i),
      !0
    );
  }
  slideToPrev() {
    this.dot_change_type = "iterate";
    let t;
    return (
      1 !== this.active_slide
        ? (this.updateActive("prev"), (t = "forwards"))
        : 1 === this.active_slide && (t = "backwards"),
      this.goToActiveSlide(!0, t),
      !0
    );
  }
  goToActiveSlide(t = !1, e = "forwards") {
    this.active_blocks &&
      this.active_blocks.forEach((t) => Transitions.reload(t.dataset.id)),
      t && this.container.setAttribute("data-transition-state", e),
      "slide" === this.transition_type
        ? this.updateContainerDestination()
        : "fade" === this.transition_type && this.fadeSlides(),
      this.old_active_blocks &&
        this.old_active_blocks.forEach((t) => Transitions.reset(t.dataset.id));
  }
  checkStartEnd() {
    this.setAttribute("data-at-start", 1 === this.active_slide),
      this.prev &&
        this.prev.setAttribute(
          "tabindex",
          1 === this.active_slide ? "-1" : "0"
        ),
      this.setAttribute("data-at-end", this.active_slide === this.slide_count),
      this.next &&
        this.next.setAttribute(
          "tabindex",
          this.active_slide === this.slide_count ? "-1" : "0"
        );
  }
  updateActive(t = !1, e = !1) {
    this.auto_slide_timer && !e && this.startAutoRotate(),
      "next" === t
        ? ((this.active_slide += 1),
          this.prev &&
            (this.autoplay_focus_enabled || !1 === this.auto_rotate) &&
            this.prev.focus())
        : "prev" === t &&
          (--this.active_slide, this.next) &&
          (this.autoplay_focus_enabled || !1 === this.auto_rotate) &&
          this.next.focus(),
      this.active_blocks && (this.old_active_blocks = this.active_blocks);
    var i = (this.active_slide - 1) * this.blocks_per_slide,
      s = i + this.blocks_per_slide;
    (this.active_blocks = [...this.blocks].slice(i, s)),
      this.toggleFocusableEl(),
      this.checkStartEnd();
  }
  toggleFocusableEl() {
    this.disabled_el &&
      this.disabled_el.forEach((t) => t.setAttribute("tabindex", "0")),
      (this.disabled_el = []),
      this.blocks.not(this.active_blocks).forEach((t) => {
        Utils.getFocusableEl(t).forEach((t) => this.disabled_el.push(t));
      }),
      this.disabled_el.length &&
        this.disabled_el.forEach((t) => t.setAttribute("tabindex", "-1"));
  }
  setSliderHeight() {
    var t = this.active_blocks.map((t) => t.offsetHeight);
    this.container.style.height = Math.max(...t) + "px";
  }
  swipeListener() {
    window.on("theme:swipe:left", () => {
      "swipe-started" === this.swipe_state &&
        ((this.slide_pause = !1),
        this.slideToNext(),
        this.setSliderHeight(),
        this.updateActiveDot(),
        this.preventClickWhenSwiping());
    }),
      window.on("theme:swipe:right", () => {
        "swipe-started" === this.swipe_state &&
          ((this.slide_pause = !1),
          this.slideToPrev(),
          this.setSliderHeight(),
          this.updateActiveDot(),
          this.preventClickWhenSwiping());
      });
  }
  createDotNav() {
    if (this.dot_nav_enabled && this.dot_nav && 1 !== this.slide_count) {
      this.dot_nav && (this.dot_nav.innerHTML = "");
      let t = "";
      for (let e = 0; e < this.slide_count; e++)
        t += `
        <button class="carousel--dot" aria-label="${e}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 42 42">
            <circle cx="16" cy="16" r="15.9155"/>
            <circle cx="16" cy="16" r="15.9155"/>
          </svg>
        </button>
      `;
      (this.dot_nav.innerHTML = t),
        (this.dots = this.dot_nav.querySelectorAll(".carousel--dot")),
        this.dots &&
          (this.dotNavListeners(), 5 < this.dots.length) &&
          this.dotTransitionListener();
    }
  }
  dotNavListeners() {
    this.dots.off("click." + this.section_id),
      this.dots.on("click." + this.section_id, ({ target: t }) => {
        this.updateThenGoToActiveSlide(t.index() + 1, !0);
      });
  }
  dotTransitionListener() {
    this.dots.off("transitionend"),
      this.dots.on("transitionend", ({ target: t }) => {
        t.parentNode === this.dots[this.active_slide - 1] &&
          (this.dot_nav.style.transform = `translateX(${this.dot_offset}px)`);
      });
  }
  updateActiveDot() {
    this.dot_nav_enabled &&
      (this.dots &&
        this.dots.forEach((t) =>
          t.setAttribute("data-active", t === this.dots[this.active_slide - 1])
        ),
      this.dots[this.active_slide - 1] && 5 < this.dots.length
        ? this.updateTrailingLeadingDots()
        : this.dot_nav_enabled && this.dot_nav.setAttribute("data-loaded", !0));
  }
  updateTrailingLeadingDots() {
    var t,
      e,
      i = this.dots[this.active_slide - 1].getAttribute("data-position"),
      s = "" !== i;
    this.active_slide === this.leading_dot_index
      ? (this.leading_dot_index++,
        this.trailing_dot_index++,
        this.dots.forEach((t) => t.setAttribute("data-position", "")),
        (t = [...this.dots].slice(this.active_slide - 3, this.active_slide)),
        4 <= this.active_slide &&
          (this.dots[this.active_slide - 4].setAttribute(
            "data-position",
            "trailing-1"
          ),
          t.push(this.dots[this.active_slide - 4])),
        5 <= this.active_slide &&
          (this.dots[this.active_slide - 5].setAttribute(
            "data-position",
            "trailing-2"
          ),
          t.push(this.dots[this.active_slide - 5])),
        this.dots.length > this.active_slide &&
          (this.dots[this.active_slide].setAttribute(
            "data-position",
            "leading-1"
          ),
          t.push(this.dots[this.active_slide])),
        this.dots.length > this.active_slide + 1 &&
          (this.dots[this.active_slide + 1].setAttribute(
            "data-position",
            "leading-2"
          ),
          t.push(this.dots[this.active_slide + 1])),
        this.dots
          .not(t)
          .forEach((t) => t.setAttribute("data-position", "hidden")),
        this.moveDots(s),
        "init" === this.dot_change_type &&
          this.dot_nav.setAttribute("data-loaded", !0))
      : this.active_slide === this.trailing_dot_index
      ? (this.leading_dot_index--,
        this.trailing_dot_index--,
        this.dots.forEach((t) => t.setAttribute("data-position", "")),
        (e = [...this.dots].slice(
          this.active_slide - 1,
          this.active_slide + 2
        )),
        2 <= this.active_slide &&
          (this.dots[this.active_slide - 2].setAttribute(
            "data-position",
            "trailing-1"
          ),
          e.push(this.dots[this.active_slide - 2])),
        3 <= this.active_slide &&
          (this.dots[this.active_slide - 3].setAttribute(
            "data-position",
            "trailing-2"
          ),
          e.push(this.dots[this.active_slide - 3])),
        this.dots.length > this.active_slide + 2 &&
          (this.dots[this.active_slide + 2].setAttribute(
            "data-position",
            "leading-1"
          ),
          e.push(this.dots[this.active_slide + 2])),
        this.dots.length > this.active_slide + 3 &&
          (this.dots[this.active_slide + 3].setAttribute(
            "data-position",
            "leading-2"
          ),
          e.push(this.dots[this.active_slide + 3])),
        this.dots
          .not(e)
          .forEach((t) => t.setAttribute("data-position", "hidden")),
        this.moveDots(s),
        "init" === this.dot_change_type &&
          this.dot_nav.setAttribute("data-loaded", !0))
      : "init" === this.dot_change_type || "hidden" === i
      ? (this.initDotIndices(), this.updateTrailingLeadingDots())
      : this.moveDots(s);
  }
  initDotIndices() {
    this.dots && this.dots.forEach((t) => t.setAttribute("data-position", "")),
      this.slide_count - this.active_slide <= 2
        ? ((this.leading_dot_index = this.active_slide),
          (this.trailing_dot_index = this.active_slide - 3))
        : 2 < this.slide_count - this.active_slide &&
          ((this.trailing_dot_index = this.active_slide),
          (this.leading_dot_index = this.active_slide + 3));
  }
  moveDots(t) {
    this.dot_nav &&
      this.dots &&
      (this.active_slide <= 3
        ? (this.dot_offset = 0)
        : this.active_slide >= this.slide_count - 2
        ? (this.dot_offset = (5 - this.slide_count) * this.dot_width)
        : (this.dot_offset = (3 - this.active_slide) * this.dot_width),
      "small" !== MediaQueries.current_window
        ? (this.dot_nav.style.transform = "translateX(0px)")
        : t ||
          (this.dot_nav.style.transform = `translateX(${this.dot_offset}px)`));
  }
  arrowNavListeners() {
    this.prev &&
      this.prev.on("click", () => {
        this.slideToPrev(), this.setSliderHeight(), this.updateActiveDot();
      }),
      this.next &&
        this.next.on("click", () => {
          this.slideToNext(), this.setSliderHeight(), this.updateActiveDot();
        });
  }
  resizeObservers() {
    new ResizeObserver(() => {
      this.carousel_width !== this.offsetWidth &&
        ((this.carousel_width = this.offsetWidth),
        this.initNewScreenSize(),
        this.setSliderHeight(),
        this.moveDots());
    }).observe(this),
      window.on("theme:mqs:updated", () => this.updateActive());
  }
  reenableClickAfterSwiping() {
    this.links.off("click." + this.section_id);
  }
  preventClickWhenSwiping() {
    this.links.on("click." + this.section_id, (t) => t.preventDefault());
  }
  startAutoRotate() {
    this.auto_slide_timer && clearInterval(this.auto_slide_timer),
      (this.auto_slide_timer = setInterval(() => {
        this.slideToNext(!0, !0),
          this.updateActiveDot(),
          this.setSliderHeight();
      }, 1e3 * this.rotate_frequency));
  }
  fadeSlides() {
    if (null !== this.active_blocks && null !== this.old_active_blocks) {
      this.blocks.forEach((t) => {
        t.setAttribute("data-active", ""),
          t.setAttribute("data-loaded", !1),
          t.setAttribute("data-mobile-loaded", !1);
      }),
        this.old_active_blocks.forEach((t) => {
          t.setAttribute("data-active", "old"), (t.style.left = "0%");
        });
      const i =
        this.total_blocks % this.blocks_per_slide == 0
          ? 0
          : this.blocks_per_slide - (this.total_blocks % this.blocks_per_slide);
      this.active_blocks.forEach((t, e) => {
        t.setAttribute("data-active", "new"),
          (t.style.left = (100 * e) / (this.total_blocks + i) + "%");
      });
    }
  }
  updateThenGoToActiveSlide(t, e = !1) {
    (this.active_slide = t),
      (this.dot_change_type = "init"),
      this.updateActive(),
      this.goToActiveSlide(e),
      this.setSliderHeight(),
      this.initDotIndices(),
      this.updateActiveDot();
  }
}
customElements.define("carousel-element", Carousel);
class Announcement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.blocks = this.querySelectorAll(".announcement--block")),
      (this.next_arrow = this.querySelector(".announcement--next")),
      (this.previous_arrow = this.querySelector(".announcement--previous")),
      (this.rotate_frequency = parseInt(
        this.getAttribute("data-rotate-frequency")
      )),
      this.getActiveBlocks(),
      this.startTimer(),
      this.resizeListeners(),
      Shopify.designMode && 1 < this.blocks.length && this.editorListeners();
  }
  getActiveBlocks() {
    (this.active_blocks = []),
      this.blocks.forEach((t) => {
        t.removeAttribute("data-index"),
          this.isBlockActive(t) && this.active_blocks.push(t);
      }),
      this.active_blocks.forEach((t, e) => {
        0 === e && t.setAttribute("data-transition-type", "slide-out"),
          t.setAttribute("data-index", e);
      }),
      (this.previous_index = 0),
      (this.next_index = 0),
      this.next_arrow &&
        this.previous_arrow &&
        this.toggleArrows(1 < this.active_blocks.length);
  }
  isBlockActive(t) {
    return (
      ("small" === MediaQueries.current_window && "small" === t.dataset.mq) ||
      ("medium" === MediaQueries.current_window &&
        "medium-large" === t.dataset.mq) ||
      ("large" === MediaQueries.current_window &&
        "medium-large" === t.dataset.mq) ||
      "" === t.dataset.mq
    );
  }
  toggleArrows(t) {
    this.next_arrow.setAttribute("aria-hidden", !t),
      this.previous_arrow.setAttribute("aria-hidden", !t),
      t
        ? this.arrowListeners()
        : [this.next_arrow, this.previous_arrow].off("click");
  }
  arrowListeners() {
    this.next_arrow.on("click", () => {
      this.disabled_click ||
        (this.updateIndices(!1),
        this.updateBlocks(),
        this.timer && clearInterval(this.timer));
    }),
      this.previous_arrow.on("click", () => {
        this.disabled_click ||
          (this.updateIndices(!0),
          this.updateBlocks(),
          this.timer && clearInterval(this.timer));
      });
  }
  startTimer() {
    this.active_blocks.length < 2 ||
      (this.timer = setInterval(() => {
        this.updateIndices(!1), this.updateBlocks();
      }, 1e3 * this.rotate_frequency));
  }
  resetBlocks() {
    this.active_blocks.forEach((t, e) => {
      var i = e === this.previous_index;
      t.off("transitionend"),
        t.setAttribute("aria-hidden", !i),
        t.setAttribute("data-transition-active", !1),
        t.setAttribute("data-transition-type", i ? "slide-out" : "slide-in");
    });
  }
  updateBlocks() {
    const e = this.active_blocks[this.next_index],
      i = this.active_blocks[this.previous_index];
    this.pending_transition && this.resetBlocks(),
      i.on("transitionend", ({ target: t }) => {
        t == i &&
          ((this.pending_transition = !1),
          e.setAttribute("aria-hidden", !1),
          e.setAttribute("data-transition-active", !0),
          i.setAttribute("aria-hidden", !0),
          i.setAttribute("data-transition-type", "slide-in"),
          i.setAttribute("data-transition-active", !1),
          i.off("transitionend"));
      }),
      e.on("transitionend", ({ target: t }) => {
        t == e &&
          ((this.disabled_click = !1),
          e.setAttribute("data-transition-type", "slide-out"),
          e.setAttribute("data-transition-active", !1),
          e.off("transitionend"));
      }),
      (this.disabled_click = !0),
      (this.pending_transition = !0),
      i.setAttribute("data-transition-active", !0);
  }
  updateIndices(t) {
    (this.previous_index = this.next_index),
      (this.next_index = t
        ? this.previous_index - 1 < 0
          ? this.active_blocks.length - 1
          : this.previous_index - 1
        : this.previous_index + 1 === this.active_blocks.length
        ? 0
        : this.previous_index + 1);
  }
  resizeListeners() {
    window.on("theme:mqs:updated", () => {
      this.getActiveBlocks(), this.resetBlocks();
    }),
      new ResizeObserver(() => this.measureHeight()).observe(this);
  }
  measureHeight() {
    document.documentElement.style.setProperty(
      "--announcement--height",
      this.offsetHeight + "px"
    );
  }
  editorListeners() {
    this.blocks.on("theme:block:deselect", () => {
      this.startTimer();
    }),
      this.blocks.on("theme:block:select", ({ target: t }) => {
        this.isBlockActive(t) &&
          ((this.next_index = parseInt(t.getAttribute("data-index"))),
          (this.previous_index =
            this.next_index - 1 < 0
              ? this.active_blocks.length - 1
              : this.next_index - 1),
          (this.pending_transition = !0),
          this.updateBlocks(),
          this.timer) &&
          clearInterval(this.timer);
      }),
      this.on("theme:section:reorder", () => {
        this.timer && clearInterval(this.timer);
      }),
      document.on("shopify:inspector:activate.Announcement", () => {
        (this.parentNode.style.position = "relative"),
          (this.parentNode.style.top = "unset");
      }),
      document.on("shopify:inspector:deactivate.Announcement", () => {
        setTimeout(() => {
          this.parentNode.removeAttribute("style");
        }, 0);
      });
  }
}
customElements.define("announcement-bar-element", Announcement);
class CollapsibleRow extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.toggle = this.querySelector(".collapsible-row--toggle")),
      (this.default_state =
        "true" === this.toggle.getAttribute("aria-expanded")),
      (this.content = this.querySelector(".collapsible-row--content")),
      (this.content_wrapper = this.querySelector(".collapsible-row--wrapper")),
      this.toggleListener(),
      this.resizeObserver();
  }
  disconnectedCallback() {
    this.toggle.off("click keydown");
  }
  toggleListener() {
    this.toggle.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        (t.preventDefault(),
        this.setTransitions(
          "true" !== this.toggle.getAttribute("aria-expanded")
        ));
    });
  }
  resizeObserver() {
    new ResizeObserver(() => this.setTransitions(this.default_state)).observe(
      this.toggle
    );
  }
  setTransitions(t) {
    this.content_wrapper &&
      (this.toggle.setAttribute("aria-expanded", t),
      this.content_wrapper.setAttribute("data-transition-active", t),
      (this.content_wrapper.style.height = t
        ? this.content.offsetHeight + "px"
        : "0px"));
  }
}
customElements.define("collapsible-row-element", CollapsibleRow);
class ConsentTracking extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.accept = this.querySelector(".popup--block--accept")),
      (this.decline = this.querySelector(".popup--block--decline")),
      (this.limit = "true" === this.parentNode.getAttribute("data-limit")),
      this.eventListeners(),
      window.Shopify &&
        window.Shopify.loadFeatures([
          {
            name: "consent-tracking-api",
            version: "0.1",
            onLoad: () => {
              var t, e, i, s;
              window.Shopify.customerPrivacy &&
              (({
                marketing: t,
                analytics: e,
                preferences: i,
              } = window.Shopify.customerPrivacy.currentVisitorConsent()),
              (s = "" === t && "" === e && "" === i),
              window.Shopify.customerPrivacy.shouldShowBanner()) &&
              s
                ? Shopify.designMode || this.open()
                : Popup && Popup.loadNext();
            },
          },
        ]);
  }
  eventListeners() {
    [this.accept, this.decline].on("click", ({ target: t }) => {
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: t === this.accept,
          marketing: t === this.accept,
          preferences: t === this.accept,
        },
        () => {
          this.close(), !this.limit && Popup && Popup.loadNext();
        }
      );
    }),
      Shopify.designMode &&
        (this.on("theme:block:deselect", () => this.close()),
        this.on("theme:block:select", () => {
          this.off("transitionend"), this.open();
        }));
  }
  open() {
    this.setAttribute("aria-hidden", !1),
      setTimeout(() => this.setAttribute("data-transition-active", !0), 5);
  }
  close() {
    this.setAttribute("data-transition-active", !1),
      this.on("transitionend", () => this.setAttribute("aria-hidden", !0), {
        once: !0,
      });
  }
}
customElements.define("consent-tracking", ConsentTracking);
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.days_container = this.querySelector(".countdown-timer--item")),
      (this.digits = this.querySelectorAll(".countdown-timer--digit")),
      (this.hide_when_expired =
        "true" === this.getAttribute("data-hide-expired")),
      (this.show_button_when = this.getAttribute("data-show-button-when"));
    var t = this.getAttribute("data-expiry-date").split("-"),
      e = this.getAttribute("data-expiry-hours"),
      i = this.getAttribute("data-expiry-minutes");
    (this.countdown_date = this.initDate(...t, e, i)),
      this.initTimer(),
      this.startTimer(),
      this.addStateListener();
  }
  disconnectedCallback() {
    this.timer && clearInterval(this.timer);
  }
  initDate(t, e, i, s, r) {
    let o;
    return (
      Utils.areNumericStrings(t, e, i)
        ? (o = new Date(Date.UTC(i, e - 1, t, s, r)))
        : ((o = new Date()).setHours(0, 0, 0, 0), o.setDate(o.getDate() + 1)),
      o.getTime()
    );
  }
  addStateListener() {
    this.digits.on("transitionend", ({ target: t }) => {
      "slide-out" === t.getAttribute("data-transition-type") &&
        t.removeAttribute("data-transition-type");
    });
  }
  initTimer() {
    var t = new Date().getTime(),
      e = new Date(t).getTime();
    (this.distance = this.countdown_date - e), this.updateTime();
  }
  startTimer() {
    this.timer = setInterval(() => {
      (this.distance -= 1e3), this.updateTime();
    }, 1e3);
  }
  updateTime() {
    var t;
    this.checkIfFinished() || ((t = this.getDigits()), this.renderDigits(t));
  }
  checkIfFinished() {
    if (0 < this.distance) return !1;
    clearInterval(this.timer);
    var t,
      e = this.closest("[data-countdown-container]");
    return (
      e &&
        (this.hide_when_expired && (e.style.display = "none"),
        (t = e.querySelector("[data-countdown-button]")) &&
        "finished" === this.show_button_when
          ? t.setAttribute("aria-hidden", !1)
          : t &&
            "active" === this.show_button_when &&
            t.setAttribute("aria-hidden", !0)),
      !0
    );
  }
  getDigits() {
    var t = Math.floor((this.distance % 6e4) / 1e3),
      e = 9 < t ? t.toString().split("").map(Number) : [0, t],
      i = Math.floor((this.distance % 36e5) / 6e4),
      s = 9 < i ? i.toString().split("").map(Number) : [0, i],
      r = Math.floor((this.distance % 864e5) / 36e5),
      o = 9 < r ? r.toString().split("").map(Number) : [0, r],
      a = Math.floor(this.distance / 864e5);
    return [
      ...(99 < a
        ? [9, 9]
        : 9 < a
        ? a.toString().split("").map(Number)
        : [0, a]),
      ...o,
      ...s,
      ...e,
    ];
  }
  renderDigits(o) {
    this.days_container.setAttribute("aria-hidden", 0 === o[0] && 0 === o[1]),
      this.digits.forEach((t, e) => {
        var i,
          s,
          r = o[e];
        r !== parseInt(t.dataset.value) &&
          (t.setAttribute("data-value", r),
          (i = parseInt(t.getAttribute("data-index"))),
          t.setAttribute("data-index", (s = 0 === i ? 1 : 0)),
          (t.children[s].textContent = r),
          t.children[s].setAttribute("data-transition-type", "slide-in"),
          t.children[i].setAttribute("data-transition-type", "slide-out"));
      });
  }
}
customElements.define("countdown-timer", CountdownTimer);
class Disclosure extends HTMLElement {
  static instances = [];
  constructor() {
    super();
  }
  connectedCallback() {
    (this.viewport = this.closest(".drawer--side, .layout--main-content")),
      Disclosure.instances.push(this),
      "loading" === document.readyState
        ? window.on("DOMContentLoaded", () => this.load())
        : this.load();
  }
  disconnectedCallback() {
    var t = Disclosure.instances.indexOf(this);
    -1 < t && Disclosure.instances.splice(t, 1);
  }
  load() {
    (this.current_option = this.querySelector(".disclosure--current-option")),
      (this.form = this.querySelector(".disclosure--form")),
      (this.input = this.querySelector('[data-item="disclosure"]')),
      (this.links = this.querySelectorAll(".disclosure--option")),
      (this.toggle = this.querySelector(".disclosure--toggle")),
      (this.type = this.getAttribute("data-type")),
      (this.toggle_and_form_gap = 8),
      (this.window_and_form_gap = 16),
      this.form.setAttribute("aria-hidden", !1),
      setTimeout(() => {
        this.updateFormListeners(),
          this.showFormWhenClick(),
          this.hideFormWhenFocusOut(),
          this.setOptionOnClick(),
          this.updateFormPosition(),
          "option-picker" !== this.type && this.optionChangeCallback();
      }, 0);
  }
  updateFormListeners() {
    new ResizeObserver(() => this.updateFormPosition()).observe(document.body),
      this.closest('.drawer--side[data-side="left"]') &&
        window.on("theme:drawer:left:opened.Disclosure", () =>
          this.updateFormPosition()
        ),
      this.closest('.drawer--side[data-side="right"]') &&
        window.on("theme:drawer:right:opened.Disclosure", () =>
          this.updateFormPosition()
        );
  }
  showFormWhenClick() {
    this.toggle.off("click.Disclosure keydown.Disclosure"),
      this.toggle.on("click.Disclosure keydown.Disclosure", (t) => {
        if ("keydown" !== t.type || "Enter" === t.key) {
          t.preventDefault();
          const e = "true" === this.toggle.getAttribute("aria-expanded");
          Disclosure.instances.forEach((t) =>
            t === this ? this.toggleFormDisplay(!e) : t.toggleFormDisplay(!1)
          );
        }
      });
  }
  hideFormWhenFocusOut() {
    this.off("keydown.Disclosure focusout.Disclosure"),
      this.on("focusout.Disclosure", ({ relatedTarget: t }) => {
        this.form.contains(t) || this.toggleFormDisplay(!1);
      }),
      this.on("keydown.Disclosure", ({ key: t }) => {
        "Escape" === t && (this.toggleFormDisplay(!1), this.toggle.focus());
      });
  }
  setOptionOnClick() {
    this.links.off("click.Disclosure keydown.Disclosure"),
      this.links.on(
        "click.Disclosure keydown.Disclosure",
        ({ key: t, type: e, target: i }) => {
          if ("Enter" === t) this.toggle.focus();
          else if ("keydown" === e) return;
          var s = i.dataset.value,
            r = i.getAttribute("data-option-value-id"),
            o = i.getAttribute("data-product-url"),
            a = i.innerHTML;
          this.toggleFormDisplay(!1),
            (this.current_option.innerHTML = a),
            this.links.forEach((t) => t.setAttribute("aria-current", !1)),
            i.setAttribute("aria-current", !0),
            (this.input.value = s),
            this.input.setAttribute("data-option-value-id", r),
            this.input.setAttribute("data-product-url", o),
            this.input.trigger("change");
        }
      );
  }
  toggleFormDisplay(t) {
    this.toggle.setAttribute("aria-expanded", t),
      this.form.setAttribute("data-transition-active", t);
  }
  updateFormPosition() {
    (this.toggle_pos = this.offset()),
      this.updateFormYPosition(),
      "option-picker" !== this.type && this.updateFormXPosition();
  }
  updateFormYPosition() {
    var t = this.viewport ? this.viewport.offsetHeight : 0,
      e =
        this.form.offsetHeight +
        this.toggle_and_form_gap +
        this.window_and_form_gap,
      i = this.toggle_pos.top,
      s = t - i - this.toggle.offsetHeight;
    this.form.style.top =
      s < e && s < i
        ? `-${this.form.offsetHeight + this.toggle_and_form_gap}px`
        : this.toggle.offsetHeight + this.toggle_and_form_gap + "px";
  }
  updateFormXPosition() {
    var t =
        (this.viewport ? this.viewport.offsetWidth : 0) - this.toggle_pos.left,
      e = this.form.offsetWidth + this.window_and_form_gap;
    this.form.style.right =
      t <= e
        ? this.toggle.offsetWidth + this.window_and_form_gap - t + "px"
        : "unset";
  }
  optionChangeCallback() {
    this.input.off("change.Disclosure"),
      this.input.on("change.Disclosure", ({ target: t }) => {
        "url-redirect" === this.type
          ? (window.location.href = t.value)
          : "localization" === this.type && t.closest("form").submit();
      });
  }
}
customElements.define("disclosure-element", Disclosure);
class EditorEvents {
  constructor() {
    Shopify.designMode && this.sectionListeners();
  }
  sectionListeners() {
    document.on("shopify:section:load", ({ target: t }) => {
      Transitions.load();
      var e = t.querySelector("[data-section-id]");
      e &&
        (console.log(
          "Event 'theme:section:load' triggered by ." + e.classList[0]
        ),
        "function" == typeof e.trigger) &&
        e.trigger("theme:section:load");
    }),
      document.on("shopify:section:unload", ({ target: t }) => {
        var e = t.querySelector("[data-section-id]");
        e &&
          (console.log(
            "Event 'theme:section:unload' triggered by ." + e.classList[0]
          ),
          "function" == typeof e.trigger) &&
          e.trigger("theme:section:unload");
      }),
      document.on("shopify:section:select", ({ target: t }) => {
        var e = t.querySelector("[data-section-id]");
        e &&
          (console.log(
            "Event 'theme:section:select' triggered by ." + e.classList[0]
          ),
          "function" == typeof e.open
            ? e.open()
            : "function" == typeof e.trigger &&
              e.trigger("theme:section:select"));
      }),
      document.on("shopify:section:deselect", ({ target: t }) => {
        var e = t.querySelector("[data-section-id]");
        e &&
          (console.log(
            "Event 'theme:section:deselect' triggered by ." + e.classList[0]
          ),
          "function" == typeof e.close
            ? e.close()
            : "function" == typeof e.trigger &&
              e.trigger("theme:section:deselect"));
      }),
      document.on("shopify:section:reorder", ({ target: t }) => {
        var e = t.querySelector("[data-section-id]");
        e &&
          (console.log(
            "Event 'theme:section:reorder' triggered by ." + e.classList[0]
          ),
          "function" == typeof e.trigger) &&
          e.trigger("theme:section:reorder");
      }),
      document.on("shopify:block:select", ({ target: t }) => {
        console.log(
          "Event 'theme:block:select' triggered by ." + t.classList[0]
        ),
          "function" == typeof t.open
            ? t.open()
            : "function" == typeof t.trigger && t.trigger("theme:block:select");
      }),
      document.on("shopify:block:deselect", ({ target: t }) => {
        console.log(
          "Event 'theme:block:deselect' triggered by ." + t.classList[0]
        ),
          "function" == typeof t.close
            ? t.close()
            : "function" == typeof t.trigger &&
              t.trigger("theme:block:deselect");
      });
  }
}
new EditorEvents();
class ElementRelocator extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    var t = this.getAttribute("data-move-into");
    (this.element_to_move_into = document.querySelector("" + t)),
      (this.element_to_move = this.querySelector(":scope > *")),
      this.element_to_move_into && this.element_to_move && this.moveElement();
  }
  disconnectedCallback() {
    this.element_to_move_into.innerHTML = "";
  }
  moveElement() {
    (this.element_to_move_into.innerHTML = ""),
      this.element_to_move_into.appendChild(this.element_to_move);
  }
}
customElements.define("element-relocator", ElementRelocator);
class FeaturedVideoSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.api = this.getAttribute("data-api")),
      (this.autoplay = "true" === this.getAttribute("data-autoplay")),
      (this.play_button = this.querySelector(".featured-video--play")),
      (this.id = this.getAttribute("data-id")),
      (this.video_id = this.getAttribute("data-video-id")),
      (this.video_wrapper = this.querySelector(".featured-video--wrapper")),
      this.autoplay ? this.loadLibraries() : this.playButtonListeners();
  }
  loadLibraries() {
    switch (this.api) {
      case "youtube":
        (window.onYouTubeIframeAPIReady = () =>
          window.trigger("theme:youtube:apiReady")),
          window.on("theme:youtube:apiReady", () => this.insertYoutubePlayer()),
          "loaded" === Utils.scripts.youtube
            ? this.insertYoutubePlayer()
            : Utils.scriptLoader("youtube", Shopify.routes.youtube);
        break;
      case "vimeo":
        import("@vendors/vimeo").then(() => this.insertVimeoPlayer());
        break;
      case "plyr":
        Utils.linkLoader(
          "/cdn/shopifycloud/plyr/v2.0/shopify-plyr.css",
          "stylesheet"
        ),
          import("@vendors/plyr").then(() => this.insertPlyrPlayer());
    }
  }
  insertVimeoPlayer() {
    void 0 !== Vimeo.Player &&
      ((this.vimeo = new Vimeo.Player(this.id + "-player", {
        id: this.video_id,
        autopause: 0,
        playsinline: this.autoplay ? 1 : 0,
        muted: this.autoplay ? 1 : 0,
        background: this.autoplay ? 1 : 0,
        loop: this.autoplay ? 1 : 0,
        title: 0,
      })),
      this.vimeo.ready().then(() => {
        this.showPlayer(),
          this.autoplay || this.vimeoEvents(),
          this.trigger("theme:video:loaded");
      }),
      Promise.all([
        this.vimeo.getVideoWidth(),
        this.vimeo.getVideoHeight(),
      ]).then(([t, e]) => this.setAspectRatio(e, t)),
      this.vimeo.play());
  }
  vimeoEvents() {
    this.vimeo.getDuration().then((t) => {
      this.vimeo.addCuePoint(t - 0.3, {});
    }),
      this.vimeo.on("cuepoint", () => {
        this.vimeo.setCurrentTime(0), this.vimeo.pause();
      });
  }
  insertYoutubePlayer() {
    var t, e;
    void 0 !== YT.Player &&
      (({ height: t, width: e } = new YT.Player(this.id + "-player", {
        videoId: this.video_id,
        playerVars: {
          enablejsapi: 1,
          host: "https://www.youtube.com",
          origin: location.origin,
        },
        events: {
          onReady: ({ target: t }) => this.youtubeReady(t),
          onStateChange: (t) => this.youtubeEvents(t),
        },
      }).getIframe()),
      this.setAspectRatio(t, e));
  }
  youtubeReady(t) {
    this.autoplay && t.mute(),
      this.showPlayer(),
      t.playVideo(),
      this.trigger("theme:video:loaded");
  }
  youtubeEvents({ target: t, data: e }) {
    this.autoplay || 0 !== e
      ? this.autoplay && 0 === e && t.playVideo()
      : (t.seekTo(0), t.pauseVideo());
  }
  insertPlyrPlayer() {
    var t;
    void 0 === Shopify.Video ||
      this.autoplay ||
      ((t = this.video_wrapper.querySelector("video")).on("ready", () =>
        this.showPlayer()
      ),
      new Shopify.Video(t, {
        autoplay: !0,
        hideControls: !0,
        muted: !1,
        loop: { active: !1 },
        controls: [
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "captions",
          "settings",
          "pip",
          "airplay",
          "fullscreen",
        ],
      }));
  }
  showPlayer() {
    setTimeout(() => {
      this.autoplay || this.setAttribute("data-overlay-style", "none"),
        this.video_wrapper.setAttribute("data-transition-active", !0),
        this.trigger("theme:video:loaded");
    }, 50);
  }
  setAspectRatio(t, e) {
    this.style.setProperty("--natural-aspect-ratio", (e / t).toFixed(4));
  }
  playButtonListeners() {
    this.play_button &&
      this.play_button.on("click keydown", (t) => {
        ("keydown" === t.type && "Enter" !== t.key) ||
          (t.preventDefault(),
          this.loadLibraries(),
          setTimeout(() => this.setAttribute("data-loaded", !0), 400));
      });
  }
}
customElements.define("featured-video", FeaturedVideoSection);
class General {
  constructor() {
    console.info(
      `%cBeyond theme v4.1.1 by Troop Themes - Learn about our JS API here:
https://support.troopthemes.com/guide/api-for-custom-code?utm_source=console&utm_medium=console`,
      [
        "background: green",
        "color: white",
        "font-weight: bold",
        "padding: 2px",
      ].join(";")
    ),
      Transitions.load(),
      Cart.fetchTotals(!0),
      QuickAdd.clearFormListeners(),
      MediaQueries.init(),
      this.setSwipeConfig(),
      "loading" === document.readyState
        ? document.on("DOMContentLoaded", () => this.load())
        : this.load();
  }
  load() {
    this.configureLinks(), this.addPrefetchListeners(), this.observeMutations();
  }
  setSwipeConfig() {
    import("@vendors/swipe-listener").then(() => {
      var t;
      window.SwipeListener &&
        ((Utils.disable_prevent_scroll = !1),
        (Utils.disable_swipe_listener = !1),
        (t = document.querySelectorAll("input, textarea")).on(
          "focus",
          () => (Utils.disable_prevent_scroll = !0)
        ),
        t.on("blur", () => (Utils.disable_prevent_scroll = !1)),
        SwipeListener(document, {
          preventScroll: ({ detail: t }) => {
            var e;
            if (!Utils.disable_prevent_scroll)
              return (
                (e = Math.abs(t.x[0] - t.x[1])),
                2 * Math.abs(t.y[0] - t.y[1]) < e
              );
          },
        }),
        document.on("swipe", (t) => {
          var e, i, s, r;
          Utils.disable_swipe_listener ||
            (({ left: e, right: i, top: s, bottom: r } = t.detail.directions),
            e && window.trigger("theme:swipe:left"),
            i && window.trigger("theme:swipe:right"),
            s && window.trigger("theme:swipe:top"),
            r && window.trigger("theme:swipe:bottom"));
        }));
    });
  }
  configureLinks() {
    document
      .querySelectorAll('[data-item="hidden-text"] a')
      .forEach((t) => t.setAttribute("tabindex", "-1")),
      document
        .querySelectorAll(
          `a[href^="http"]:not([href*="${window.location.hostname}"])`
        )
        .forEach((t) => t.setAttribute("target", "_blank"));
  }
  addPrefetchListeners() {
    var t = document.querySelectorAll("a[href]");
    t.length &&
      (t.off("mouseover.General"),
      t.on("mouseover.General", ({ target: t }) => {
        var e = t.href ? t : t.closest("a[href]");
        e && Utils.linkLoader(e.href, "prefetch", "high", "document");
      }));
  }
  observeMutations() {
    new MutationObserver(() => {
      this.addPrefetchListeners(), this.configureLinks();
    }).observe(document.body, { childList: !0, subtree: !0 });
  }
}
new General();
class Header extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.primary_nav = this.querySelector(".header--primary-nav")),
      (this.container = this.primary_nav.parentNode),
      (this.x_gap_and_padding = 128),
      (this.layout = this.getAttribute("data-layout")),
      (this.logo = this.querySelector(".header--logo")),
      (this.scroll_hide = "true" === this.getAttribute("data-scroll-hide")),
      (this.secondary_nav = this.querySelector(".header--secondary-nav")),
      (this.sticky = "true" === this.getAttribute("data-sticky")),
      (this.transparent_enabled =
        "true" === this.getAttribute("data-transparent-enabled")),
      (this.overlap_behavior = this.getAttribute("data-overlap-behavior")),
      (this.prev_scroll_pos = window.scrollY),
      (this.x_menu = this.primary_nav.querySelector(".x-menu")),
      (this.minimum_expanded_width =
        this.x_menu.offsetWidth +
        this.secondary_nav.offsetWidth +
        this.logo.offsetWidth +
        this.x_gap_and_padding),
      this.resizeObserver(),
      this.sticky && this.scrollListener(),
      this.setAttribute("data-loaded", !0),
      Shopify.designMode && this.addShopifyListeners();
  }
  disconnectedCallback() {
    window.off("scroll.Header");
  }
  resizeObserver() {
    new ResizeObserver(() => {
      (this.root_rect = this.getBoundingClientRect()),
        this.scrollCallback(),
        this.checkHorizontalOverflow(),
        this.measureHeight();
    }).observe(this);
  }
  checkHorizontalOverflow() {
    let t = !1;
    switch (this.layout) {
      case "center-left":
        this.enableOverlap(t);
        var e = this.primary_nav.getBoundingClientRect()["right"],
          i = this.logo.getBoundingClientRect()["left"];
        t = i < e + 16;
        break;
      case "left-center":
      case "left-left":
        t = this.minimum_expanded_width > this.container.offsetWidth;
        break;
      case "center-below":
        this.enableOverlap(t),
          (t = this.container.offsetWidth < this.primary_nav.offsetWidth + 64);
    }
    this.primary_nav.setAttribute("aria-hidden", !1),
      "drawer" != this.layout && this.enableOverlap(t);
  }
  enableOverlap(t) {
    this.setAttribute("aria-expanded", t),
      t
        ? this.setAttribute("data-layout", this.overlap_behavior)
        : this.setAttribute("data-layout", this.layout);
  }
  measureHeight() {
    (this.hide_offset = (
      this.root_rect.top +
      window.scrollY +
      this.root_rect.height
    ).toFixed(2)),
      document.documentElement.style.setProperty(
        "--header--height",
        this.root_rect.height.toFixed(2) + "px"
      );
  }
  scrollListener() {
    window.on(
      "scroll.Header",
      () => {
        this.animation_request && cancelAnimationFrame(this.animation_request),
          (this.animation_request = requestAnimationFrame(() =>
            this.scrollCallback()
          ));
      },
      { passive: !0 }
    );
  }
  scrollCallback() {
    var t;
    Drawer.status.includes("clos") &&
      "opened" !== Modal.status &&
      this.root_rect &&
      ((t = window.scrollY),
      this.setAttribute("data-sticky", this.root_rect.top < t),
      this.scroll_hide) &&
      (t <= this.hide_offset
        ? (this.setAttribute("aria-hidden", !1),
          document.documentElement.style.setProperty("--header--sticky", 1))
        : (this.setAttribute("aria-hidden", t > this.prev_scroll_pos),
          document.documentElement.style.setProperty(
            "--header--sticky",
            t > this.prev_scroll_pos ? 0 : 1
          )),
      (this.prev_scroll_pos = t));
  }
  addShopifyListeners() {
    document.on("shopify:inspector:activate.Header", () => {
      (this.parentNode.style.position = "relative"),
        (this.parentNode.style.top = "unset");
    }),
      document.on("shopify:inspector:deactivate.Header", () => {
        setTimeout(() => {
          this.parentNode.removeAttribute("style");
        }, 0);
      }),
      document.on("shopify:section:load shopify:section:unload", () => {
        (this.root_rect = this.getBoundingClientRect()), this.measureHeight();
      }),
      this.on("shopify:block:deselect", () => {
        this.setAttribute("data-sticky", !1);
      }),
      this.on("shopify:block:select", () => {
        this.setAttribute("data-sticky", !0);
      }),
      this.on("theme:section:load", () => {
        Drawer.loadTriggers(), this.measureHeight();
      });
  }
}
customElements.define("header-element", Header);
class ImageComparisonSection extends HTMLElement {
  constructor() {
    super(),
      (this.container = this.querySelector(".image-comparison--images")),
      (this.cursor = this.querySelector(".image-comparison--cursor")),
      (this.direction = this.getAttribute("data-cursor-direction")),
      (this.text_containers = this.querySelectorAll(
        ".image-comparison--before-text, .image-comparison--after-text"
      ));
  }
  connectedCallback() {
    this.transitionObserver(),
      this.getDimensions(),
      this.cursorListeners(),
      this.resizeObserver();
  }
  transitionObserver() {
    this.on("transitionend", ({ target: t }) => {
      t === this.cursor.parentNode &&
        (this.style.setProperty("--image-comparison--transition", "none"),
        this.off("transitionend"));
    }),
      new IntersectionObserver(
        ([{ isIntersecting: t }], e) => {
          t &&
            (e.disconnect(),
            this.setCursor(this.getAttribute("data-initial-pos")));
        },
        { threshold: 0.3 }
      ).observe(this.container);
  }
  setCursor(t) {
    this.style.setProperty("--image-comparison--cursor-pos", t + "%");
  }
  getDimensions() {
    (this.total =
      "horizontal" === this.direction
        ? this.container.offsetWidth
        : this.container.offsetHeight),
      (this.offset =
        "horizontal" === this.direction
          ? this.container.offset().left
          : this.container.offset().top);
  }
  resizeObserver() {
    new ResizeObserver(() => this.getDimensions()).observe(this);
  }
  cursorListeners() {
    var t = window.matchMedia("(pointer: coarse)").matches;
    const e = "vertical" === this.direction && t;
    this.cursor.on(
      "mousedown touchstart",
      () => {
        (this.cursor.style.cursor = "grabbing"),
          (Utils.disable_swipe_listener = !0),
          this.toggleText(!1);
      },
      { passive: !0 }
    ),
      window.on(
        "mousemove touchmove",
        (t) => {
          Utils.disable_swipe_listener &&
            (e && t.preventDefault(),
            this.animation_request &&
              cancelAnimationFrame(this.animation_request),
            (this.animation_request = requestAnimationFrame(() =>
              this.moveCursor(t)
            )));
        },
        { passive: !e }
      ),
      window.on(
        "mouseup touchend",
        () => {
          (this.cursor.style.cursor = "unset"),
            (Utils.disable_swipe_listener = !1),
            this.toggleText(!0);
        },
        { passive: !0 }
      );
  }
  toggleText(e) {
    this.text_containers.length &&
      this.text_containers.forEach((t) =>
        t.setAttribute("data-transition-active", e)
      );
  }
  moveCursor(t) {
    let e,
      i =
        ("horizontal" === this.direction
          ? (e = ("touchmove" === t.type ? t.targetTouches[0] : t).pageX)
          : "vertical" === this.direction &&
            (e = ("touchmove" === t.type ? t.targetTouches[0] : t).pageY),
        ((100 * (e - this.offset)) / this.total).toFixed(2));
    95 < i ? (i = 95) : i < 5 && (i = 5), this.setCursor(i);
  }
}
customElements.define("image-comparison-element", ImageComparisonSection);
class MapSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.address = this.getAttribute("data-address")),
      (this.center = null),
      (this.container = this.querySelector(".map--google-maps")),
      (this.key = this.getAttribute("data-api-key")),
      (this.styles = null),
      (this.theme = this.getAttribute("data-theme")),
      "" !== this.key &&
        Utils.scriptLoader(
          "google_maps_" + this.key,
          "https://maps.googleapis.com/maps/api/js?key=" + this.key,
          () => this.load()
        );
  }
  load() {
    new google.maps.Geocoder().geocode({ address: this.address }, (t, e) => {
      "OK" === e
        ? ((this.center = t[0].geometry.location),
          this.buildStyles(),
          this.buildMap(),
          this.resizeObserver())
        : console.error("Google Maps: couldn't convert address with geocoder");
    });
  }
  buildMap() {
    (this.map = new google.maps.Map(this.container, {
      zoom: 15,
      center: this.center,
      disableDefaultUI: !0,
      zoomControl: !0,
      scrollwheel: !1,
      styles: this.styles,
    })),
      new google.maps.Marker({ map: this.map, position: this.center });
  }
  buildStyles() {
    "grayscale" === this.theme
      ? (this.styles = [
          { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f5f5" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#e5e5e5" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#dadada" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ color: "#e5e5e5" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#c9c9c9" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
        ])
      : "dark" === this.theme &&
        (this.styles = [
          { elementType: "geometry", stylers: [{ color: "#212121" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#212121" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#181818" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1b1b1b" }],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{ color: "#2c2c2c" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#8a8a8a" }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#373737" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#3c3c3c" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#4e4e4e" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#000000" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#3d3d3d" }],
          },
        ]);
  }
  resizeObserver() {
    new ResizeObserver(() => this.map.setCenter(this.center)).observe(this);
  }
}
customElements.define("map-element", MapSection);
class MasonryGrid extends HTMLElement {
  constructor() {
    super(), (this.masonry = !1);
  }
  connectedCallback() {
    import("@vendors/masonry").then(() => {
      this.loadMasonry(), this.resizeListener();
    });
  }
  loadMasonry() {
    var t;
    "small" !== MediaQueries.current_window &&
      window.Masonry &&
      ((t = "." + this.childNodes[0].classList[0]),
      (this.masonry = new Masonry(this, {
        itemSelector: t,
        percentPosition: !0,
        horizontalOrder: !0,
        columnWidth: t,
        gutter: this.dataset.gap ? parseInt(this.dataset.gap) : 0,
        transitionDuration: "0.2s",
        initLayout: !1,
      })),
      this.masonry.once("layoutComplete", () => {
        window.trigger("theme:masonry:layoutComplete"),
          this.setAttribute("data-masonry-loaded", !0);
      }),
      this.masonry.layout());
  }
  resizeListener() {
    window.on("theme:mqs:updated", () => {
      "small" === MediaQueries.current_window || this.masonry
        ? "small" === MediaQueries.current_window &&
          this.masonry &&
          this.unloadMasonry()
        : this.loadMasonry();
    });
  }
  unloadMasonry() {
    this.setAttribute("data-masonry-loaded", !1),
      this.masonry.destroy(),
      (this.masonry = !1);
  }
}
customElements.define("masonry-grid-element", MasonryGrid);
class Navigation extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    "loading" === document.readyState
      ? window.on("DOMContentLoaded", () => this.load())
      : this.load();
  }
  load() {
    this.initGrid(),
      this.initNavigation(),
      this.initFilter(),
      this.navigationListener(),
      Shopify.designMode && Drawer.loadTriggers();
  }
  initGrid() {
    (this.body = document.querySelector("[data-body-root]")),
      (this.grid_container = this.body.querySelector("[data-body-grid]")),
      (this.max_columns = parseInt(this.body.getAttribute("data-max-columns"))),
      (this.num_columns = parseInt(
        this.grid_container.getAttribute("data-columns")
      )),
      (this.pagination = this.body.querySelector("[data-body-pagination]")),
      (this.pagination_link = this.body.querySelector(
        "[data-body-pagination-link]"
      )),
      (this.spinner = this.body.querySelector("[data-body-spinner]"));
  }
  initNavigation() {
    (this.active_price_tag = this.querySelector(
      '.navigation--active-tag[data-type="price"]'
    )),
      (this.active_min =
        this.active_price_tag.querySelector("[data-min-price]")),
      (this.active_max =
        this.active_price_tag.querySelector("[data-max-price]")),
      (this.active_refine_tag = this.querySelector(
        '.navigation--active-tag[data-type="refine"]'
      )),
      (this.active_sort_tag = this.querySelector(
        '.navigation--active-tag[data-type="sort"]'
      )),
      (this.active_tags_container = this.querySelector(
        ".navigation--tags-container"
      )),
      (this.active_tags_wrapper = this.querySelector(
        ".navigation--active-tags"
      )),
      (this.clear_tags_button = this.querySelector(
        ".navigation--active-clear"
      )),
      (this.layout_buttons = this.querySelectorAll(
        ".navigation--layout-button"
      )),
      (this.local_storage_name =
        Shopify.theme.name + ":" + this.getAttribute("data-storage-name")),
      (this.navigation_buttons = this.querySelectorAll(
        ".navigation--button, .navigation--mobile-button"
      )),
      (this.small_layout_button = this.layout_buttons[1]),
      (this.url = this.getAttribute("data-url")),
      this.layout_buttons.length && 2 < this.max_columns
        ? (this.initLayout(), this.setLayout(), this.layoutListener())
        : this.layout_buttons.forEach((t) => (t.style.display = "none"));
  }
  initFilter() {
    (this.filter = document.querySelector(".filter--root")),
      this.filter &&
        ((this.browse_links = this.filter.querySelectorAll(
          '[data-type="browse"] .filter--label'
        )),
        (this.current_sort_input = this.filter.querySelector(
          '[data-type="sort"] .filter--input:checked'
        )),
        (this.filter_form = this.filter.querySelector(".filter--form")),
        (this.menu_toggles = this.filter.querySelectorAll(".filter--toggle")),
        (this.price_range = this.filter.querySelector(".price-range--wrapper")),
        (this.refine_links = this.filter.querySelectorAll(
          '[data-type="refine"] .filter--label'
        )),
        (this.reset_button = this.filter.querySelector(
          '.filter--button[data-type="reset"]'
        )),
        (this.sort_links = this.filter.querySelectorAll(
          '[data-type="sort"] .filter--label'
        )),
        this.menu_toggles.length &&
          (this.menuToggleListeners(), this.clearAllListener()),
        this.browse_links.length && this.browseListener(),
        this.sort_links.length &&
          (this.current_sort_input &&
            ((this.current_sort_link =
              this.current_sort_input.nextElementSibling),
            (this.current_sort_value = this.current_sort_input.value),
            (this.current_sort_label =
              this.current_sort_input.getAttribute("data-label"))),
          this.sortListener(),
          this.renderActiveSort(),
          this.activeSortListener()),
        this.refine_links.length &&
          (this.refineListener(), this.renderActiveRefines()),
        this.price_range &&
          (this.renderActivePriceListener(),
          this.getNewProductsListener(),
          this.activePriceListener()),
        this.toggleActiveTags());
  }
  navigationListener() {
    this.navigation_buttons.on(
      "click keydown",
      ({ key: t, target: e, type: i }) => {
        ("keydown" === i && "Enter" !== t) ||
          this.toggleFilterMenu(e.getAttribute("data-toggle-menu"));
      }
    );
  }
  toggleFilterMenu(e) {
    document.querySelectorAll(".filter--toggle").forEach((t) => {
      t.setAttribute("aria-expanded", !1),
        t.nextElementSibling.setAttribute("data-transition-active", !1),
        t.getAttribute("aria-controls").includes(e) && t.click();
    });
  }
  initLayout() {
    this.layout_buttons.forEach((t) => t.removeAttribute("style")),
      this.small_layout_button.setAttribute(
        "data-column-size",
        this.max_columns
      );
  }
  setLayout() {
    let e = parseInt(localStorage.getItem(this.local_storage_name));
    (e && (2 === e || e === this.num_columns)) ||
      ((e = this.num_columns),
      localStorage.setItem(this.local_storage_name, e)),
      this.grid_container.setAttribute("data-columns", e),
      this.layout_buttons.forEach((t) => {
        t.setAttribute("data-active", !1),
          parseInt(t.getAttribute("data-column-size")) === e &&
            t.setAttribute("data-active", !0);
      });
  }
  layoutListener() {
    this.layout_buttons.off("click keydown"),
      this.layout_buttons.on("click keydown", (t) => {
        var e;
        ("keydown" === t.type && "Enter" !== t.key) ||
          ((e = parseInt(t.target.getAttribute("data-column-size"))),
          localStorage.setItem(this.local_storage_name, e),
          this.setLayout());
      });
  }
  menuToggleListeners() {
    this.menu_toggles.on("click keydown", (t) => {
      if ("keydown" !== t.type || "Enter" === t.key) {
        var e = t.target;
        const i = "true" !== e.getAttribute("aria-expanded"),
          s = (e.setAttribute("aria-expanded", i), e.nextElementSibling);
        setTimeout(() => s.setAttribute("data-transition-active", i), 0);
      }
    });
  }
  clearAllListener() {
    [this.clear_tags_button, this.reset_button].on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        (this.current_sort_link && this.current_sort_link.click(),
        window.trigger("theme:priceRange:clear"),
        this.active_refine_tags.length &&
          this.active_refine_tags.forEach((t) => t.trigger("click")),
        t.target.focus());
    });
  }
  browseListener() {
    this.browse_links.on("click keydown", (i) => {
      if ("keydown" !== i.type || "Enter" === i.key) {
        const s = i.target.previousElementSibling;
        let t = !1,
          e;
        s.checked && (t = !0),
          setTimeout(() => {
            (e = t
              ? ((s.checked = !1), Shopify.routes.all_products_collection)
              : s.value),
              (location.href = "" + location.origin + e),
              setTimeout(() => Drawer.close(), 350);
          }, 0);
      }
    });
  }
  sortListener() {
    this.sort_links.on("click keydown", (e) => {
      if ("keydown" !== e.type || "Enter" === e.key) {
        const i = e.target,
          s = i.previousElementSibling;
        let t = !1;
        s.checked && (t = !0),
          setTimeout(() => {
            t
              ? ((s.checked = !1),
                (this.current_sort_link = !1),
                (this.current_sort_label = !1),
                (this.current_sort_value = !1))
              : ((s.checked = !0),
                (this.current_sort_link = i),
                (this.current_sort_label = s.dataset.label),
                (this.current_sort_value = s.value)),
              this.showLoadingView(),
              this.renderActiveSort(),
              this.getAjaxUrl();
          }, 0);
      }
    });
  }
  refineListener() {
    this.refine_links.on("click keydown", (t) => {
      var e;
      ("keydown" === t.type && "Enter" !== t.key) ||
        ("Enter" === t.key &&
          ((e = t.target.previousElementSibling).checked = !e.checked),
        setTimeout(() => {
          this.clearRefineTags(),
            this.showLoadingView(),
            this.renderActiveRefines(),
            this.getAjaxUrl();
        }, 0));
    });
  }
  clearRefineTags() {
    var t = this.active_tags_wrapper.querySelectorAll(
      '.navigation--active-tag[data-type="refine"]'
    );
    t.length && t.forEach((t) => t.remove());
  }
  getNewProductsListener() {
    window.on("theme:navigation:loadNewProducts", () => {
      this.showLoadingView(), this.getAjaxUrl();
    });
  }
  getAjaxUrl() {
    var t = new FormData(this.filter_form),
      e = new URLSearchParams(t);
    (this.ajax_url = "" + this.url + e.toString()),
      history.replaceState({}, "", this.ajax_url),
      this.getGridHtml(),
      this.toggleActiveTags();
  }
  showLoadingView() {
    (this.grid_container.innerHTML = ""),
      [this.grid_container, this.pagination].forEach(
        (t) => (t.style.display = "none")
      ),
      (this.spinner.style.display = "flex");
  }
  async getGridHtml() {
    this.abort_controller && this.abort_controller.abort(),
      (this.abort_controller = new AbortController());
    try {
      if (
        ((this.response = await fetch(this.ajax_url, {
          signal: this.abort_controller.signal,
        })),
        !this.response.ok)
      )
        throw new Error(response.statusText);
      var t = (await this.response.text()).parse("[data-body-root]");
      this.renderGridHtml(t),
        (this.spinner.style.display = "none"),
        this.grid_container.removeAttribute("style"),
        setTimeout(() => this.loadTransitions(), 0),
        window.trigger("theme:navigation:reloaded");
    } catch {}
  }
  renderGridHtml(t) {
    var e = t.querySelector("[data-body-grid]").innerHTML,
      i =
        ((this.grid_container.innerHTML = e),
        t.querySelector("[data-body-pagination]"));
    i
      ? ((this.pagination.innerHTML = i.innerHTML),
        this.pagination.removeAttribute("style"),
        this.pagination_link && (this.pagination_link.style.display = "block"))
      : this.pagination_link && (this.pagination_link.style.display = "none");
  }
  loadTransitions() {
    [
      ...this.grid_container.querySelectorAll("[data-transition-container]"),
    ].map((t) => Transitions.load(t)),
      Transitions.reload(this.body.dataset.sectionId);
  }
  renderActiveSort() {
    this.current_sort_value
      ? ((this.render_active_sort = !0),
        (this.active_sort_tag.querySelector("span").textContent =
          this.current_sort_label),
        this.active_sort_tag.setAttribute(
          "data-value",
          this.current_sort_value
        ),
        this.active_sort_tag.removeAttribute("style"))
      : ((this.render_active_sort = !1),
        (this.active_sort_tag.style.display = "none"));
  }
  renderActivePriceListener() {
    window.on("theme:priceRange:renderActive", ({ detail: t }) => {
      0 === t.current_min && t.current_max === t.max
        ? ((this.active_price_tag.style.display = "none"),
          (this.render_active_price = !1))
        : ((this.render_active_price = !0),
          (this.active_min.textContent = "" + t.current_min),
          (this.active_max.textContent = "" + t.current_max),
          this.active_price_tag.removeAttribute("style")),
        this.toggleActiveTags();
    });
  }
  renderActiveRefines() {
    (this.active_refine_tags = []), (this.render_active_refine = !1);
    const i = { labels: [], names: [], swatches: [], values: [] };
    if (
      (this.filter
        .querySelectorAll('[data-type="refine"] input:checked')
        .forEach((t) => {
          i.labels.push(t.getAttribute("data-label")),
            i.names.push(t.name),
            i.values.push(t.value);
          var e = t.nextElementSibling;
          "swatch" === e.getAttribute("data-item")
            ? i.swatches.push(e.getAttribute("style"))
            : i.swatches.push(!1);
        }),
      0 < i.values.length)
    ) {
      var t = new DocumentFragment();
      for (let e = 0; e < i.values.length; e++) {
        var s = this.active_refine_tag.cloneNode(!0),
          r =
            (s.removeAttribute("style"),
            s.setAttribute("data-value", i.values[e]),
            s.setAttribute("data-name", i.names[e]),
            (s.querySelector("span").textContent = i.labels[e]),
            s.querySelectorAll('[class*="swatch"]'));
        i.swatches[e] && r.length
          ? r.forEach((t) => t.setAttribute("style", i.swatches[e]))
          : r.length && r.forEach((t) => t.remove()),
          t.prepend(s),
          this.active_refine_tags.push(s);
      }
      this.active_tags_wrapper.prepend(t),
        (this.render_active_refine = !0),
        this.activeRefineListeners();
    }
  }
  toggleActiveTags() {
    var t =
      this.render_active_refine ||
      this.render_active_sort ||
      this.render_active_price;
    this.active_tags_container.style.display = t ? "block" : "none";
  }
  activeSortListener() {
    this.active_sort_tag.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        (this.current_sort_link && this.current_sort_link.click());
    });
  }
  activePriceListener() {
    this.active_price_tag.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        window.trigger("theme:priceRange:clear");
    });
  }
  activeRefineListeners() {
    this.active_refine_tags.on("click keydown", (t) => {
      if ("keydown" !== t.type || "Enter" === t.key) {
        const r = t.target;
        this.refine_links.forEach((t) => {
          var e = t.previousElementSibling,
            i = r.getAttribute("data-value"),
            s = r.getAttribute("data-name");
          e.value === i && e.name === s && (t.click(), (e.checked = !1));
        });
      }
    });
  }
}
customElements.define("navigation-element", Navigation);
class PasswordPage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.login_form = this.querySelector(".password--login-form")),
      (this.login_cancel = this.querySelector(".password--cancel")),
      (this.login_link = this.querySelector(".password--login-link")),
      (this.login_input = this.login_form.querySelector(
        'input[type="password"]'
      )),
      this.loginFormListener(),
      this.cancelLoginListener();
  }
  loginFormListener() {
    this.login_link.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        (t.preventDefault(),
        this.setAttribute("data-show-login", !0),
        this.login_input.focus());
    });
  }
  cancelLoginListener() {
    this.login_cancel.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        this.setAttribute("data-show-login", !1);
    });
  }
}
customElements.define("password-element", PasswordPage);
class Placeholder extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.querySelectorAll("path").forEach((t) => {
      var e = Math.ceil(t.getTotalLength());
      t.setStyles({ strokeDasharray: e, strokeDashoffset: e });
    });
  }
}
customElements.define("placeholder-element", Placeholder);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.form = this.querySelector("form")),
      (this.clear_button = this.querySelector(".search--clear")),
      (this.input = this.querySelector(".search--textbox")),
      (this.results = this.querySelector(".search--results")),
      (this.cached_results = { "": this.results.innerHTML }),
      this.listenForKeyEntered(),
      this.formSubmit(),
      this.clearButtonListener(),
      this.addMutationObserver();
  }
  listenForKeyEntered() {
    this.input.on("input", () => {
      var t = this.input.value.trim();
      (this.clear_button.style.display = "" === t ? "none" : "flex"),
        this.getSearchResults(t);
    });
  }
  async getSearchResults(t) {
    this.abort_controller && this.abort_controller.abort();
    var e = t.trim();
    if (this.cached_results[e]) this.results.innerHTML = this.cached_results[e];
    else {
      (this.abort_controller = new AbortController()), this.toggleLoading(!0);
      try {
        var i = await fetch(
          `${Shopify.routes.predictive_search}?q=${encodeURIComponent(
            t
          )}&section_id=predictive-search`,
          { signal: this.abort_controller.signal }
        );
        if (!i.ok) throw new Error(i.status);
        var s = (await i.text()).parse().innerHTML;
        (this.cached_results[e] = s), (this.results.innerHTML = s);
      } catch {}
    }
  }
  clearButtonListener() {
    this.clear_button.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        (t.preventDefault(),
        (this.input.value = ""),
        this.input.focus(),
        this.input.trigger("input"));
    });
  }
  toggleLoading(t) {
    setTimeout(() => this.setAttribute("data-loading", t), t ? 0 : 100);
  }
  formSubmit() {
    this.form.on("submit", (t) => {
      t.preventDefault(),
        (window.location.href =
          Shopify.routes.search +
          "?type=product&q=" +
          encodeURIComponent(this.input.value.trim()));
    });
  }
  addMutationObserver() {
    new MutationObserver(() => {
      this.toggleLoading(!1),
        window.trigger("theme:search:reloaded"),
        Transitions.reload("search");
    }).observe(this.results, { childList: !0 });
  }
}
customElements.define("predictive-search-element", PredictiveSearch);
class PriceRange extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.active_price_tag = document.querySelector(
      '.navigation--active-tag[data-type="price"]'
    )),
      (this.button_min_delta = 32),
      (this.container = this.closest(".filter--menu")),
      (this.price_inputs = this.querySelectorAll(".price-range--input")),
      (this.price_range_buttons = this.querySelectorAll(
        ".price-range--button"
      )),
      (this.price_range_line = this.querySelector(".price-range--line")),
      (this.price_range_transition =
        this.price_range_buttons[0].style.transition);
    var t,
      e,
      i = parseFloat(
        this.price_inputs[1].getAttribute("max").replace(",", ".")
      );
    0 !== i &&
      ((t = parseFloat(this.price_inputs[0].value.replace(",", "."))),
      (e = parseFloat(this.price_inputs[1].value.replace(",", "."))),
      (this.prices = {
        current_min: t,
        pending_min: t,
        current_max: e,
        pending_max: e,
        max: i,
      }),
      this.priceRangeListeners(),
      this.priceRangeResizeObserver(),
      this.priceInputListeners(),
      this.renderActivePrice(),
      this.clearPriceListener());
  }
  priceRangeResizeObserver() {
    new ResizeObserver(() => this.getPriceRangeGeometry()).observe(
      this.price_range_line
    );
  }
  priceInputListeners() {
    this.price_inputs.on("keydown", (t) => {
      var e = t.which;
      (e < 48 || 57 < e) &&
        (e < 37 || 40 < e) &&
        8 !== e &&
        9 !== e &&
        13 !== e &&
        65 !== e &&
        67 !== e &&
        86 !== e &&
        88 !== e &&
        91 !== e &&
        188 !== e &&
        190 !== e &&
        t.preventDefault();
    }),
      this.price_inputs.on("change", (t) => {
        var e = t.target,
          i = parseFloat(e.value);
        let s, r;
        e.dataset.hasOwnProperty("minPrice")
          ? i + this.price_min_delta > this.prices.current_max
            ? (i > this.prices.max - this.price_min_delta
                ? ((s = parseFloat(
                    (this.prices.max - this.price_min_delta).toFixed(2)
                  )),
                  (this.prices.current_max = this.prices.max))
                : ((s = i),
                  (this.prices.current_max = parseFloat(
                    (i + this.price_min_delta).toFixed(2)
                  ))),
              (e.value = s),
              (this.prices.current_min = s),
              (this.price_inputs[1].value = this.prices.current_max))
            : (this.prices.current_min = i)
          : e.dataset.hasOwnProperty("maxPrice") &&
            (i > this.prices.max
              ? ((e.value = this.prices.max),
                (this.prices.current_max = this.prices.max))
              : this.prices.current_min + this.price_min_delta > i
              ? (i - this.price_min_delta < 0
                  ? ((r = this.price_min_delta.toFixed(2)),
                    (this.prices.current_min = 0))
                  : ((r = i),
                    (this.prices.current_min = parseFloat(
                      (i - this.price_min_delta).toFixed(2)
                    ))),
                (e.value = r),
                (this.prices.current_max = r),
                (this.price_inputs[0].value = this.prices.current_min))
              : (this.prices.current_max = i)),
          this.getPriceRangePositions(),
          this.movePriceRangeButtons(),
          this.setPriceRangeFill(),
          this.renderActivePrice(),
          window.trigger("theme:navigation:loadNewProducts");
      });
  }
  getPriceRangeGeometry() {
    (this.price_range_width = this.price_range_line.offsetWidth),
      this.price_range_width &&
        ((this.pixels_per_price = this.price_range_width / this.prices.max),
        (this.price_per_pixels = this.prices.max / this.price_range_width),
        (this.price_min_delta =
          this.button_min_delta * (1 / this.pixels_per_price)),
        this.getPriceRangePositions(),
        this.movePriceRangeButtons(),
        this.setPriceRangeFill());
  }
  getPriceRangePositions() {
    this.price_positions = {
      min: this.prices.current_min * this.pixels_per_price,
      max: this.prices.current_max * this.pixels_per_price,
    };
  }
  movePriceRangeButtons() {
    this.price_range_buttons.forEach((t) => {
      t.style.transform = t.dataset.hasOwnProperty("maxPrice")
        ? `translateX(-${this.price_range_width - this.price_positions.max}px)`
        : `translateX(${this.price_positions.min}px)`;
    });
  }
  setPriceRangeFill() {
    var t = this.price_range_line.firstElementChild,
      e = this.price_range_width - this.price_positions.max;
    t.setStyles({
      margin: `0 ${e}px 0 ${this.price_positions.min}px`,
      width: `calc(100% - ${e + this.price_positions.min}px)`,
    });
  }
  priceRangeListeners() {
    this.price_range_buttons.on(
      "mousedown.priceRange touchstart.priceRange",
      (t) => {
        (this.active_range_button = t.target),
          (Utils.disable_swipe_listener = !0),
          (this.drag_start = (
            "touchstart" === t.type ? t.targetTouches[0] : t
          ).pageX);
      },
      { passive: !0 }
    ),
      window.on(
        "mousemove.priceRange touchmove.priceRange",
        (t) => {
          this.drag_start &&
            (this.animation_request &&
              cancelAnimationFrame(this.animation_request),
            (this.animation_request = requestAnimationFrame(() =>
              this.getNewButtonPosition(t)
            )));
        },
        { passive: !0 }
      ),
      window.on(
        "mouseup.priceRange touchend.priceRange",
        () => {
          this.drag_start &&
            ((this.drag_start = !1),
            (Utils.disable_swipe_listener = !1),
            this.active_range_button.dataset.hasOwnProperty("maxPrice")
              ? ((this.prices.current_max = parseFloat(
                  this.prices.pending_max
                )),
                (this.price_inputs[1].value = this.prices.current_max))
              : ((this.prices.current_min = parseFloat(
                  this.prices.pending_min
                )),
                (this.price_inputs[0].value = this.prices.current_min)),
            this.getPriceRangePositions(),
            this.renderActivePrice(),
            window.trigger("theme:navigation:loadNewProducts"));
        },
        { passive: !0 }
      );
  }
  getNewButtonPosition(t) {
    var e = t.type.includes("touch")
      ? t.targetTouches[0].pageX - this.drag_start
      : t.pageX - this.drag_start;
    if (this.active_range_button.dataset.hasOwnProperty("maxPrice")) {
      let t = this.prices.current_max * this.pixels_per_price + e;
      t > this.price_range_width
        ? (t = this.price_range_width)
        : this.price_positions.min > t - this.button_min_delta &&
          (t = this.price_positions.min + this.button_min_delta),
        (this.price_positions.max = t),
        (this.prices.pending_max = (t * this.price_per_pixels).toFixed(2)),
        (this.price_inputs[1].value = this.prices.pending_max);
    } else {
      let t = this.prices.current_min * this.pixels_per_price + e;
      t < 0
        ? (t = 0)
        : t > this.price_positions.max - this.button_min_delta &&
          (t = this.price_positions.max - this.button_min_delta),
        (this.price_positions.min = t),
        (this.prices.pending_min = (t * this.price_per_pixels).toFixed(2)),
        (this.price_inputs[0].value = this.prices.pending_min);
    }
    this.movePriceRangeButtons(), this.setPriceRangeFill();
  }
  renderActivePrice() {
    window.trigger("theme:priceRange:renderActive", this.prices);
  }
  clearPrices() {
    let i = !1;
    this.price_inputs.forEach((t) => {
      var e = parseFloat(t.value);
      t.dataset.hasOwnProperty("minPrice") && 0 !== e
        ? ((t.value = 0), (i = !0))
        : t.dataset.hasOwnProperty("maxPrice") &&
          e !== this.prices.max &&
          ((t.value = this.prices.max), (i = !0));
    }),
      i && this.price_inputs.forEach((t) => t.trigger("change"));
  }
  clearPriceListener() {
    window.on("theme:priceRange:clear", () => this.clearPrices());
  }
}
customElements.define("price-range-element", PriceRange);
class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.cart_type = this.getAttribute("data-cart-type")),
      (this.primary_button = this.querySelector(
        ".product-buy-buttons--primary"
      )),
      (this.button_text = this.querySelector(".product-buy-buttons--cta-text")),
      (this.input = this.querySelector(".product-buy-buttons--input")),
      (this.smart_button = this.querySelector(".product-buy-buttons--smart")),
      (this.translations = JSON.parse(
        this.querySelector("script").textContent
      )),
      this.addToCartListener(),
      this.updateViewListener();
  }
  addToCartListener() {
    this.closest("form").on("submit", async (t) => {
      var e = t.target.querySelector("[name=quantity]"),
        i = Utils.getQuantity(this.dataset.id, this.input.dataset, e.value);
      if (
        (("drawer" !== this.cart_type && !1 !== i) ||
          (t.preventDefault(), t.stopPropagation()),
        i &&
          (this.primary_button.setAttribute("aria-busy", !0),
          "drawer" === this.cart_type))
      ) {
        var s = new FormData(t.target),
          r = {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(s).toString(),
          };
        try {
          await Cart.addItems(r, this.input.value),
            this.primary_button.setAttribute("aria-busy", !1),
            Drawer.open("right", "cart-drawer", this.primary_button);
        } catch (t) {
          throw (
            (this.primary_button.setAttribute("aria-busy", !1), new Error(t))
          );
        }
      }
    });
  }
  updateViewListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        t && t.available
          ? (this.selectVariant(t), this.updateView(!0, !0))
          : t && !t.available
          ? (this.selectVariant(t), this.updateView(!1, !0))
          : this.updateView(!1, !1);
      }
    );
  }
  selectVariant({
    id: t,
    sku: e,
    inventory_management: i,
    inventory_policy: s,
    inventory_quantity: r,
  }) {
    (this.input.value = t),
      this.input.setAttribute("data-sku", e),
      this.input.setAttribute("data-management", i),
      this.input.setAttribute("data-policy", s),
      this.input.setAttribute("data-quantity", r);
  }
  updateView(t, e) {
    t
      ? (this.primary_button.removeAttribute("disabled"),
        (this.button_text.textContent = this.translations.add_to_cart),
        this.smart_button && this.smart_button.setAttribute("aria-hidden", !1))
      : (this.primary_button.setAttribute("disabled", !0),
        this.smart_button && this.smart_button.setAttribute("aria-hidden", !0),
        (this.button_text.textContent = e
          ? this.translations.out_of_stock
          : this.translations.unavailable));
  }
}
customElements.define("product-buy-buttons-element", ProductBuyButtons);
class ProductCarousel extends Carousel {
  constructor() {
    super();
  }
  load() {
    super.load(), this.updateMediaListener(), this.onSlideFinishedListener();
    var t = this.querySelector('.product-media--root[data-active="true"]');
    this.goToSlide(t ? t.dataset.id : 0);
  }
  updateMediaListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        var e = t.featured_media ? parseInt(t.featured_media.id) : 0;
        this.goToSlide(e);
      }
    );
  }
  onSlideFinishedListener() {
    const i = this.querySelectorAll(".product-media--root");
    this.container.on("transitionend", () => {
      var t = this.active_slide - 1,
        e = i[t];
      i.not(e).forEach((t) => t.firstChild.trigger("pauseMedia"));
    });
  }
  goToSlide(t) {
    var e, i;
    0 !== t &&
      (e = this.querySelector(`.product-media--root[data-id='${t}']`)) &&
      ((i = e.closest(".carousel--block").index() + 1),
      this.updateThenGoToActiveSlide(i));
  }
  checkForActiveModel(t) {
    var e = t.querySelector("model-viewer");
    return !!e && !e.classList.contains("shopify-model-viewer-ui__disabled");
  }
}
customElements.define("product-carousel", ProductCarousel);
class ProductLowStock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.initial_availability = "true" === this.dataset.initialAvailability),
      (this.initial_quantity = parseInt(this.dataset.initialQuantity)),
      (this.message = this.querySelector(".product-low-stock--message")),
      (this.threshold = parseInt(this.dataset.threshold)),
      (this.translations = JSON.parse(
        this.querySelector('script[id*="low_stock_translations"]').textContent
      )),
      this.updateListener(),
      this.initial_availability
        ? this.update(this.initial_quantity)
        : this.show(!1);
  }
  updateListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        t && t.available ? this.update(t.inventory_quantity) : this.show(!1);
      }
    );
  }
  update(t) {
    let e;
    !t || t < 1 || t > this.threshold
      ? this.show(!1)
      : (1 === t
          ? (e = (e = this.translations.low_in_stock.one).replace("&#39;", "'"))
          : 1 < t &&
            (e = (e = this.translations.low_in_stock.other)
              .replace(/\d+/, t)
              .replace("&#39;", "'")),
        this.style.setProperty(
          "--progress-percent",
          (100 * t) / this.threshold + "%"
        ),
        (this.message.textContent = e),
        this.show(!0));
  }
  show(t) {
    this.parentNode.setAttribute("aria-hidden", !t);
  }
}
customElements.define("product-low-stock-element", ProductLowStock);
class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.layout = this.dataset.layout),
      (this.masonry_container = this.querySelector("[data-masonry-layout]")),
      (this.media = this.querySelectorAll(".product-media--root")),
      (this.playable_media = this.querySelectorAll(
        ".product-model--root, .product-video--root"
      )),
      (this.scroll_enabled =
        "true" === this.getAttribute("data-variant-scroll")),
      this.pauseListener(),
      this.updateMediaListeners(),
      this.masonry_container &&
        ((this.gap = parseInt(this.masonry_container.dataset.gap)),
        this.getMasonryBlocks(),
        this.resizeObserver());
  }
  disconnectedCallback() {
    this.playable_media.off("click." + this.dataset.id),
      window.off(
        `theme:product:${this.dataset.id}:variantChanged.ProductMedia theme:product:${this.dataset.id}:mediaChanged.ProductMedia`
      );
  }
  pauseListener() {
    this.playable_media.on("click." + this.dataset.id, ({ target: t }) => {
      var e = t.closest(".product-model--root, .product-video--root");
      this.playable_media.not(e).forEach((t) => t.trigger("pauseMedia"));
    });
  }
  updateMediaListeners() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged.ProductMedia`,
      ({ detail: { variant: t } }) => {
        var e = t.featured_media ? parseInt(t.featured_media.id) : 0;
        this.updateVariantMedia(e);
      }
    ),
      window.on(
        `theme:product:${this.dataset.id}:mediaChanged.ProductMedia`,
        ({ detail: { id: t } }) => this.updateVariantMedia(t)
      );
  }
  updateVariantMedia(i) {
    0 !== i &&
      this.media.forEach((t) => {
        var e = parseInt(t.dataset.id) === i;
        t.setAttribute("data-active", e),
          t.children[0].trigger(e ? "playMedia" : "pauseMedia"),
          e &&
            ("one" == this.layout || "two" == this.layout
              ? this.scrollToMedia(parseInt(t.offset().top))
              : "mixed" == this.layout &&
                (this.updateMixedMedia(t),
                this.scrollToMedia(parseInt(this.offset().top))));
      });
  }
  scrollToMedia(t) {
    var e, i;
    this.scroll_enabled &&
      "small" !== MediaQueries.current_window &&
      ((i =
        "" ===
        (e = document.documentElement.style.getPropertyValue("--sticky-offset"))
          ? 0
          : parseInt(e.replace("px", ""))),
      window.scrollTo({ top: t - i - 8, left: 0, behavior: "smooth" }));
  }
  updateMixedMedia(t) {
    var e = this.querySelector(".product-media--active .product-media--root");
    e &&
      (this.swapMedia(t, e),
      (this.media = this.querySelectorAll(".product-media--root"))),
      this.masonry_container && this.getMasonryBlocks();
  }
  swapMedia(t, e) {
    t.replaceWith(e.cloneNode(!0)), e.replaceWith(t.cloneNode(!0));
  }
  getMasonryBlocks() {
    (this.left_blocks = this.masonry_container.querySelectorAll(
      ":scope > :nth-child(odd)"
    )),
      (this.right_blocks = this.masonry_container.querySelectorAll(
        ":scope > :nth-child(even)"
      )),
      this.setMasonryLayout();
  }
  setMasonryLayout() {
    var t = this.getColumnHeight(this.left_blocks),
      e = this.getColumnHeight(this.right_blocks),
      i =
        e < t
          ? t + this.gap * (this.left_blocks.length - 1)
          : e + this.gap * (this.right_blocks.length - 1);
    this.masonry_container.style.height = i + 1 + "px";
  }
  getColumnHeight(t) {
    return Math.ceil(
      [...t].reduce((t, e) => t + e.getBoundingClientRect().height, 0)
    );
  }
  resizeObserver() {
    new ResizeObserver(() => this.setMasonryLayout()).observe(
      this.masonry_container
    );
  }
}
customElements.define("product-media-variants", ProductMedia);
class ProductModel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.view = this.getAttribute("data-view")),
      (this.json = JSON.parse(
        document.querySelector("[id*=model_json").textContent
      )),
      this.eventListeners(),
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: () => this.loadShopifyXr(),
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => this.loadModel(),
        },
      ]);
  }
  eventListeners() {
    this.on("theme:section:load", () => this.loadModel()),
      this.on("pauseMedia", () => !!this.model && this.model.pause()),
      this.on("playMedia", () => !!this.model && this.model.play()),
      new ResizeObserver(() => this.trigger("pauseMedia")).observe(this);
  }
  loadModel() {
    this.model ||
      !Shopify.ModelViewerUI ||
      ("small" === MediaQueries.current_window && "desktop" === this.view) ||
      ("small" !== MediaQueries.current_window && "mobile" === this.view) ||
      ((this.model = new Shopify.ModelViewerUI(
        this.querySelector("model-viewer")
      )),
      window.trigger("theme:product:mediaLoaded"));
  }
  loadShopifyXr() {
    window.ShopifyXR
      ? this.models_added ||
        (window.ShopifyXR.addModels(this.json),
        window.ShopifyXR.setupXRElements(),
        (this.models_added = !0))
      : document.addEventListener("shopify_xr_initialized", () =>
          this.loadShopifyXr()
        );
  }
}
customElements.define("product-model-element", ProductModel);
class ProductOptions extends HTMLElement {
  static variant_caches = {};
  constructor() {
    super();
  }
  connectedCallback() {
    (this.current_product_url = this.getAttribute("data-product-url")),
      (this.handle = this.getAttribute("data-product-handle")),
      (this.inputs = this.querySelectorAll("input")),
      (this.is_product_page = null !== this.closest(".product-page--root")),
      (this.is_quick_add = null !== this.closest(".product--quick-add--form")),
      (this.options = this.querySelectorAll(
        "label[data-option-value-id], li[data-option-value-id]"
      )),
      (this.product_id = this.getAttribute("data-product-id")),
      (this.section_root = this.is_quick_add
        ? this.closest(".product--quick-add--form")
        : this.closest("[data-section-id]")),
      (this.section_id = this.is_quick_add
        ? "product--quick-add--form"
        : this.section_root.getAttribute("data-section-id")),
      this.setCurrentOptions(),
      this.initSizeChart(),
      this.optionChangeListener(),
      this.loadVariantObserver(),
      this.preventFormSubmitOnEnter(),
      Shopify.designMode && this.editorListeners();
  }
  initSizeChart() {
    var t = this.querySelector(
      ".product-options--option .product-size-chart--root"
    );
    t &&
      (t.parentNode.querySelector("label").appendChild(t),
      t.removeAttribute("style"));
  }
  optionChangeListener() {
    this.querySelectorAll('[data-item="disclosure"], [data-item="radio"]').on(
      "change.ProductOptions",
      async ({ target: t }) => {
        this.setAttribute("aria-busy", !0), this.setCurrentOptions();
        var e,
          i,
          s,
          r,
          o = this.generateCacheKey(this.current_options),
          a = t.getAttribute("data-product-url");
        let n;
        ProductOptions.variant_caches[o]
          ? (n = await ProductOptions.variant_caches[o])
          : ((n = await this.fetchData(a, this.current_options)),
            (ProductOptions.variant_caches[o] = n)),
          "" !== a && a != this.current_product_url
            ? ((e = n.firstChild),
              this.section_root.parentNode.replaceChild(e, this.section_root),
              this.is_quick_add && QuickAdd
                ? ((i = e.getAttribute("data-handle")) &&
                    (QuickAdd.forms[i] = e),
                  delete QuickAdd.forms[this.handle])
                : (Transitions.reload("viewport"),
                  Shopify.PaymentButton && Shopify.PaymentButton.init(),
                  this.is_product_page &&
                    history.replaceState({ path: a }, "", a)))
            : ((s = n.querySelector(".product-options--root")),
              (this.outerHTML = s.outerHTML),
              (r = JSON.parse(
                s.querySelector("[id*=variant-json]").textContent
              )),
              this.updateVariant(r || !1));
      }
    );
  }
  loadVariantObserver() {
    new IntersectionObserver(
      ([{ isIntersecting: t }], e) => {
        t && (this.loadVariantHtml(), e.disconnect());
      },
      { threshold: 0 }
    ).observe(this);
  }
  loadVariantHtml() {
    this.options.forEach((t) => {
      const e = {
        value_id: t.getAttribute("data-option-value-id"),
        name: t.getAttribute("data-option-name"),
      };
      var i = this.current_options.map((t) => (t.name === e.name ? e : t)),
        s = this.generateCacheKey(i),
        r = t.getAttribute("data-product-url");
      ProductOptions.variant_caches[s] ||
        (ProductOptions.variant_caches[s] = this.fetchData(r, i));
    });
  }
  setCurrentOptions() {
    var t = this.querySelectorAll(
      '[data-item="disclosure"], [data-item="radio"]:checked'
    );
    this.current_options = [...t].map((t) => ({
      value_id: t.getAttribute("data-option-value-id"),
      name: t.getAttribute("data-option-name"),
    }));
  }
  generateCacheKey(t) {
    return t.map((t) => t.value_id).join("_");
  }
  async fetchData(t, e) {
    var i = "" === t ? this.current_product_url : t,
      s = e.map((t) => t.value_id).join(","),
      r = await fetch(`${i}?section_id=${this.section_id}&option_values=` + s);
    return r.ok ? (await r.text()).parse() : null;
  }
  preventFormSubmitOnEnter() {
    this.inputs.length &&
      this.inputs.on("keydown", (t) => "Enter" === t.key && t.preventDefault());
  }
  updateVariant(t) {
    this.is_product_page && this.updateHistoryState(t),
      window.trigger(`theme:product:${this.dataset.id}:variantChanged`, {
        variant: t,
      });
  }
  updateHistoryState(t) {
    let e = location.pathname;
    t && (e += "?variant=" + t.id), history.replaceState({ path: e }, "", e);
  }
  editorListeners() {
    var t = this.closest("[data-shopify-editor-block]");
    t &&
      t.on("theme:block:select", () => {
        (ProductOptions.variant_caches[this.section_id] = {}),
          (ProductOptions.variant_caches =
            ProductOptions.variant_caches[this.section_id]);
      });
  }
}
customElements.define("product-options-element", ProductOptions);
class ProductPickup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.init = "true" === this.getAttribute("data-load-first-variant")),
      (this.product_title = this.getAttribute("data-title")),
      (this.pickup_drawer_container = document.querySelector(
        '.drawer--container[data-view="pickup"]'
      )),
      this.initPickup(),
      this.updatePickupListener();
  }
  initPickup() {
    this.init
      ? this.getPickupForm(this.dataset.firstVariantId)
      : this.parentNode.setAttribute("aria-hidden", !0);
  }
  updatePickupListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        t.available && "shopify" === t.inventory_management
          ? this.getPickupForm(t.id)
          : (t && "shopify" === t.inventory_management && t.available) ||
            this.removeOldForm();
      }
    );
  }
  async getPickupForm(t) {
    this.setAttribute("data-loading", !0);
    var e = await fetch(
      Shopify.routes.root + `variants/${t}/?section_id=pickup`
    );
    if (!e.ok) throw new Error(e.statusText);
    var i,
      s = await e.text(),
      r = s.parse(".pickup--form--container");
    this.removeOldForm(),
      this.setAttribute("data-loading", !1),
      r &&
        (this.appendChild(r),
        this.parentNode.setAttribute("aria-hidden", !1),
        ((i = s.parse(".pickup--drawer--container")).querySelector(
          ".pickup--drawer--product-title"
        ).textContent = this.product_title),
        "true" === this.getAttribute("data-is-only-variant") &&
          (i.querySelector(".pickup--drawer--variant-title").style.display =
            "none"),
        this.pickup_drawer_container.appendChild(i),
        Drawer.loadTriggers());
  }
  removeOldForm() {
    this.parentNode.setAttribute("aria-hidden", !0),
      (this.pickup_drawer_container.innerHTML = ""),
      (this.innerHTML = "");
  }
}
customElements.define("product-pickup-element", ProductPickup);
class ProductPrice extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.compare_price = this.querySelector(".product-price--compare")),
      (this.price = this.querySelector(".product-price--original")),
      (this.money_format = this.getAttribute("data-money-format")),
      (this.reference_unit = this.querySelector(
        ".product-price--reference-unit"
      )),
      (this.reference_value = this.querySelector(
        ".product-price--reference-value"
      )),
      (this.unit_price = this.querySelector(".product-price--unit-price")),
      (this.unit_price_container = this.querySelector(
        ".product-price--unit-container"
      )),
      this.updatePriceListener();
  }
  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
  }
  updatePriceListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged.ProductPrice`,
      ({ detail: { variant: t } }) => {
        this.updatePrices(t);
      }
    );
  }
  updatePrices(t) {
    t
      ? (this.parentNode.setAttribute("aria-hidden", !1),
        (this.price.innerHTML = this.formatMoney(t.price)),
        t.compare_at_price > t.price
          ? ((this.compare_price.innerHTML = this.formatMoney(
              t.compare_at_price
            )),
            (this.compare_price.style.display = "inline-block"))
          : (this.compare_price.style.display = "none"),
        t.unit_price_measurement
          ? ((this.unit_price.innerHTML = this.formatMoney(t.unit_price)),
            (this.reference_unit.innerHTML =
              t.unit_price_measurement.reference_unit),
            1 === t.unit_price_measurement.reference_value &&
            this.reference_value
              ? (this.reference_value.style.display = "none")
              : this.reference_value &&
                ((this.reference_value.innerHTML =
                  t.unit_price_measurement.reference_value),
                (this.reference_value.style.display = "block")),
            (this.unit_price_container.style.display = "flex"))
          : (this.unit_price_container.style.display = "none"))
      : this.parentNode.setAttribute("aria-hidden", !0);
  }
  formatMoney(t) {
    var e = this.money_format.includes("no_decimals") ? 0 : 2,
      i = this.money_format.includes("comma") ? "de-DE" : "en-US",
      s = Intl.NumberFormat(i, {
        minimumFractionDigits: e,
        maximumFractionDigits: e,
      }).format(t / 100);
    return this.money_format.replace(/\{\{\s*(\w+)\s*\}\}/, s);
  }
}
customElements.define("product-price-element", ProductPrice);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.block = this.closest('[data-block-type="complementary-products"]')),
      (this.container = this.querySelector("[data-products-container]")),
      (this.intent = this.dataset.intent),
      (this.max_products = this.getAttribute("data-max-products")),
      (this.product_id = this.getAttribute("data-product-id")),
      this.load();
  }
  async load() {
    var t = await fetch(
      `${Shopify.routes.product_recommendations}?section_id=${this.intent}-products&limit=${this.max_products}&product_id=${this.product_id}&intent=` +
        this.intent
    );
    if (!t.ok) throw new Error(t.statusText);
    var e = (await t.text()).parse().querySelectorAll("[data-product-item]");
    if (e.length) {
      const i = new DocumentFragment();
      e.forEach((t) => i.append(t)),
        (this.container.innerHTML = ""),
        this.container.appendChild(i),
        (this.style.display = "block"),
        Transitions.reload("related-products");
    } else this.block && (this.block.style.display = "none");
  }
}
const productRecommendationsEl = customElements.get(
  "product-recommendations-element"
);
productRecommendationsEl ||
  customElements.define(
    "product-recommendations-element",
    ProductRecommendations
  );
class ProductSKU extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.text_container = this.querySelector("span")),
      this.show("" !== this.text_container.textContent),
      this.updateSKUListener();
  }
  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.ProductSku`);
  }
  updateSKUListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged.ProductSku`,
      ({ detail: { variant: t } }) => {
        this.show("" !== t.sku), (this.text_container.textContent = t.sku);
      }
    );
  }
  show(t) {
    this.parentNode.style.display = t ? "block" : "none";
  }
}
customElements.define("product-sku-element", ProductSKU);
class ProductThumbs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.thumbs = this.querySelectorAll(".product-media--thumb")),
      (this.wrapper = this.querySelector(".product-media--thumbs-wrapper")),
      this.updateMediaListener(),
      this.clickListener();
  }
  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.ProductThumbs`);
  }
  updateMediaListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged.ProductThumbs`,
      ({ detail: { variant: t } }) => {
        t.featured_media && this.updateActive(t.featured_media.id);
      }
    );
  }
  clickListener() {
    this.thumbs.on("keypress click", ({ target: t }) => {
      var e = parseInt(t.dataset.id);
      this.updateActive(e),
        window.trigger(`theme:product:${this.dataset.id}:mediaChanged`, {
          id: e,
        });
    });
  }
  updateActive(i) {
    this.thumbs.forEach((t) => {
      var e = parseInt(t.dataset.id);
      t.setAttribute("data-active", e === i), e === i && this.scrollIntoView(t);
    });
  }
  scrollIntoView(t) {
    var e = this.getBoundingClientRect(),
      i = t.getBoundingClientRect(),
      s = i.top - e.top;
    let r;
    (r =
      s < e.height / 2
        ? this.wrapper.scrollTop + s - (e.height - i.height) / 2
        : this.wrapper.scrollTop + s - e.height / 2 + i.height / 2),
      this.wrapper.scrollTo({ top: r, behavior: "smooth" });
  }
}
customElements.define("product-thumbs-element", ProductThumbs);
class ProductUnavailableForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.form_value = this.querySelector(".product-unavailable--value")),
      (this.input = this.querySelector(".product-unavailable--input")),
      (this.submit = this.querySelector(".product-unavailable--submit")),
      this.submitListener(),
      this.displayListener();
  }
  submitListener() {
    this.submit.on("click", (t) => {
      t.preventDefault(),
        Utils.isValidEmail(this.input.value)
          ? this.sendRequest()
          : FeedbackBar.load("email-invalid");
    });
  }
  async sendRequest() {
    this.setAttribute("aria-busy", !0),
      this.submit.setAttribute("disabled", !0);
    var t = await fetch(Shopify.routes.root + "contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        form_type: "contact",
        contact: { email: this.input.value, message: this.form_value.value },
      }),
    });
    if (t.redirected && !t.url.includes("contact_posted=true"))
      window.location.href = t.url;
    else {
      if (!t.ok) throw new Error(t.statusText);
      (this.input.value = ""),
        FeedbackBar.load("product-form"),
        this.setAttribute("aria-busy", !1),
        this.submit.removeAttribute("disabled");
    }
  }
  displayListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        this.setAttribute("aria-hidden", !t || t.available),
          t &&
            (this.form_value.value =
              this.form_value.value.split(":")[0] + ": " + t.name);
      }
    );
  }
}
const productUnavailableFormEl = customElements.get(
  "product-unavailable-element"
);
productUnavailableFormEl ||
  customElements.define("product-unavailable-element", ProductUnavailableForm);
class ProductVideo extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.view = this.getAttribute("data-view")),
      (this.type = this.getAttribute("data-type")),
      (this.loop_enabled = "true" === this.getAttribute("data-loop-enabled")),
      this.resizeObserver(),
      "youtube" === this.type
        ? ((window.onYouTubeIframeAPIReady = () =>
            window.trigger("theme:youtube:apiReady")),
          this.youtubeListeners(),
          Utils.scriptLoader("youtube", Shopify.routes.youtube))
        : (this.plyrListeners(),
          Utils.linkLoader(
            "/cdn/shopifycloud/plyr/v2.0/shopify-plyr.css",
            "stylesheet"
          ),
          import("@vendors/plyr").then(() => this.insertPlyrPlayer()));
  }
  plyrListeners() {
    this.on("theme:section:load", () => this.loadPlyrVideo()),
      this.on("pauseMedia", () => {
        this.video && this.video.pause();
      }),
      this.on("playMedia", () => {
        this.video && this.video.play();
      });
  }
  youtubeListeners() {
    window.on("theme:youtube:apiReady", () => this.loadYoutubeVideo()),
      this.on("theme:section:load", () => this.loadYoutubeVideo());
  }
  resizeObserver() {
    new ResizeObserver(() => this.trigger("pauseMedia")).observe(this);
  }
  loadPlyrVideo() {
    this.video ||
      this.skipVideo() ||
      !Shopify.Video ||
      ((this.video = new Shopify.Video(this.querySelector("video"), {
        iconUrl: "/cdn/shopifycloud/plyr/v2.0/shopify-plyr.svg",
        loop: { active: this.loop_enabled },
      })),
      window.trigger("theme:product:mediaLoaded"));
  }
  loadYoutubeVideo() {
    var t, e;
    this.video ||
      this.skipVideo() ||
      !YT.Player ||
      ((t = this.querySelector(".product-video")),
      (e = this.getAttribute("data-video-id")),
      (this.video = new YT.Player(t, {
        videoId: e,
        events: {
          onReady: (t) => {
            this.on("pauseMedia", () => t.target.pauseVideo()),
              this.on("playMedia", () => t.target.playVideo());
          },
          onStateChange: (t) => {
            var e;
            0 === t.data && this.loop_enabled && t.target.seekTo(0),
              1 === t.data &&
                (e = document
                  .querySelectorAll(
                    ".product-model--root, .product-video--root"
                  )
                  .not(this)).length &&
                e.forEach((t) => t.trigger("pauseMedia"));
          },
        },
      })),
      window.trigger("theme:product:mediaLoaded"));
  }
  skipVideo() {
    return (
      ("small" === MediaQueries.current_window && "desktop" === this.view) ||
      ("small" !== MediaQueries.current_window && "mobile" === this.view)
    );
  }
}
customElements.define("product-video-element", ProductVideo);
class ProductZoom extends HTMLElement {
  constructor() {
    super(),
      (this.enlarged_image = this.querySelector(".product-zoom--enlarged")),
      (this.magnify = parseFloat(this.dataset.magnify));
  }
  connectedCallback() {
    this.updateGeometry(), this.resizeObserver(), this.mouseListeners();
  }
  updateGeometry() {
    var { offsetHeight: t, offsetWidth: e } = this,
      i = e * this.magnify,
      s = t * this.magnify;
    (this.enlarged_image.style.width = i + "px"),
      (this.x_ratio = (i - e) / e),
      (this.y_ratio = (s - t) / t);
  }
  resizeObserver() {
    new ResizeObserver(() => {
      this.updateGeometry();
    }).observe(this);
  }
  mouseListeners() {
    this.on("mouseenter", () => (this.enlarged_image.style.display = "block")),
      this.on("mouseleave", () => (this.enlarged_image.style.display = "none")),
      this.on("mousemove", ({ pageX: t, pageY: e }) => {
        this.mousemove_request && cancelAnimationFrame(this.mousemove_request),
          (this.mousemove_request = requestAnimationFrame(() =>
            this.moveEnlargedImage(t, e)
          ));
      });
  }
  moveEnlargedImage(t, e) {
    var { left: i, top: s } = this.offset();
    this.enlarged_image.setStyles({
      left: (i - t) * this.x_ratio + "px",
      top: (s - e) * this.y_ratio + "px",
    });
  }
}
customElements.define("product-zoom-element", ProductZoom);
class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.minus = this.querySelector(".quantity-selector--minus")),
      (this.plus = this.querySelector(".quantity-selector--plus")),
      (this.input = this.querySelector(".quantity-selector--input")),
      (this.remove = this.querySelector(".quantity-selector--remove")),
      this.inputListener(),
      this.plusListener(),
      this.minusListener(),
      (this.type = this.getAttribute("data-type")),
      "cart" === this.type
        ? ((this.cart = this.closest(".cart--root")),
          (this.line_num =
            this.closest(".cart--item").getAttribute("data-line-num")),
          this.removeListener())
        : "product" === this.type && this.updateValueListener();
  }
  inputListener() {
    let e;
    this.input.on("keydown", (t) => {
      var e = t["which"];
      (e < 48 || 57 < e) &&
        (e < 37 || 40 < e) &&
        8 !== e &&
        9 !== e &&
        t.preventDefault();
    }),
      this.input.on(
        "focusin",
        async ({ target: t }) => (e = parseInt(t.value))
      ),
      this.input.on("focusout", async () => {
        var t = parseInt(this.input.value);
        isNaN(t) || t === e
          ? (this.input.value = e)
          : ((this.input.value = t), this.callback(t));
      });
  }
  plusListener() {
    this.plus.on("click keydown", (t) => {
      var e;
      ("keydown" === t.type && "Enter" !== t.key) ||
        (t.preventDefault(),
        (e =
          0 < parseInt(this.input.value) ? parseInt(this.input.value) + 1 : 1),
        (this.input.value = e),
        this.callback(e));
    });
  }
  minusListener() {
    this.minus.on("click keydown", (t) => {
      var e;
      ("keydown" === t.type && "Enter" !== t.key) ||
        (t.preventDefault(),
        1 !== parseInt(this.input.value) &&
          ((e =
            1 < parseInt(this.input.value) - 1
              ? parseInt(this.input.value) - 1
              : 1),
          (this.input.value = e),
          this.callback(e)));
    });
  }
  removeListener() {
    this.remove.on("click", () => this.callback(0));
  }
  updateValueListener() {
    window.on(
      `theme:product:${this.dataset.id}:updateQuantity`,
      ({ detail: t }) => {
        (this.input.value = t), this.input.trigger("focusout");
      }
    );
  }
  callback(t) {
    "cart" === this.type
      ? this.cart.tryToUpdateQuantity(this.line_num, t)
      : "product" === this.type &&
        window.trigger(`theme:product:${this.dataset.id}:quantityChanged`, t);
  }
}
customElements.define("quantity-selector", QuantitySelector);
class RecentProductsSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.grid_container = this.querySelector(".recent-products--grid")),
      (this.fragment = new DocumentFragment()),
      (this.spinner = this.querySelector(".recent-products--spinner")),
      (this.storage = JSON.parse(
        localStorage.getItem(Shopify.theme.name + ":recent_products")
      )),
      this.storage ? this.load() : (this.style.display = "none");
  }
  load() {
    var t = this.storage.map((t) => this.renderProductItem(t));
    Promise.allSettled(t).then(() => this.productsLoaded());
  }
  async renderProductItem(t) {
    var e,
      i = await fetch(Shopify.routes.root + `products/${t}?view=ajax-item`);
    i.ok &&
      ((e = (await i.text()).parse(".product--root")),
      this.fragment.prepend(e));
  }
  productsLoaded() {
    this.grid_container.prepend(this.fragment),
      Transitions.reload("recents"),
      this.grid_container.removeAttribute("style"),
      (this.spinner.style.display = "none");
  }
}
customElements.define("recent-products-element", RecentProductsSection);
class ServiceListSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.block_list = this.querySelectorAll(".service-list--blocks")),
      (this.blocks = this.querySelectorAll("li")),
      (this.blocks_container = this.querySelector(".service-list--container")),
      (this.headers = this.querySelectorAll(".service-list--block-header")),
      (this.single_column = this.querySelector(".service-list--single-column")),
      (this.left_column = this.querySelector(".service-list--left-column")),
      (this.right_column = this.querySelector(".service-list--right-column")),
      (this.with_multiple_headers = 1 < this.block_list.length),
      this.balanceColumns();
  }
  balanceColumns() {
    const r = this.assignLoopList();
    r.forEach((e, t) => {
      if (this.thresholdBreached()) {
        const s = new DocumentFragment();
        this.single_column
          .querySelectorAll(".service-list--blocks")
          .forEach((t) => s.append(t)),
          void this.right_column.appendChild(s);
      } else {
        var i;
        this.with_multiple_headers
          ? this.left_column.appendChild(e)
          : e.classList.contains("service-list--block-header")
          ? (this.blocks_container.prepend(
              e.querySelector(".service-list--block-header--text")
            ),
            e.remove())
          : this.left_column
              .querySelectorAll(".service-list--blocks")
              .forEach((t) => t.appendChild(e)),
          t === r.length - 1 &&
            "" === this.right_column.innerHTML &&
            1 < this.headers.length &&
            ((i = this.left_column.querySelectorAll(".service-list--blocks")),
            this.right_column.appendChild(i[i.length - 1]));
      }
    });
  }
  assignLoopList() {
    var t;
    return this.with_multiple_headers
      ? (this.setAttribute("data-has-headers", !0), this.block_list)
      : ((t = '<ul class="service-list--blocks"></ul>'.parse()),
        this.left_column.appendChild(t),
        this.blocks);
  }
  thresholdBreached() {
    var t = this.single_column.offsetHeight,
      e = this.left_column.offsetHeight,
      i = this.right_column.offsetHeight;
    return e >= parseFloat(i + t);
  }
}
customElements.define("service-list-element", ServiceListSection);
class ShareUrl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    var t = this.querySelectorAll("[aria-hidden]");
    this.clickListener(),
      navigator.share &&
        t.forEach((t) => {
          var e = "true" != t.getAttribute("aria-hidden");
          t.setAttribute("aria-hidden", e);
        });
  }
  clickListener() {
    this.on("click", (t) => {
      var e, i;
      navigator.share
        ? ((i = (e = document.querySelector('meta[name="description"]'))
            ? e.getAttribute("content")
            : null),
          navigator.share({
            title: document.title,
            text: i,
            url: window.location.href,
          }))
        : (t.preventDefault(), FeedbackBar.trigger("copy"));
    });
  }
}
customElements.define("share-url", ShareUrl);
class ShopTheLookSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.add = this.querySelector(".shop-the-look--add")),
      (this.hotspots = this.querySelectorAll(".shop-the-look--button")),
      (this.dots = this.querySelectorAll(".shop-the-look--dot")),
      (this.products = this.querySelectorAll(".shop-the-look--product")),
      (this.product_ids = this.getProductIds()),
      this.buttonListener(),
      this.addToCartListener(),
      Shopify.designMode && this.blockListener();
  }
  getProductIds() {
    return [...this.products]
      .map((t) => parseInt(t.getAttribute("data-product-id")))
      .filter((t) => !isNaN(t));
  }
  addToCartListener() {
    this.add &&
      this.add.on("click", async () => {
        if (0 !== this.product_ids.length) {
          this.add.setAttribute("aria-busy", !0);
          var t = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: this.product_ids.map((t) => ({ id: t, quantity: 1 })),
            }),
          };
          try {
            await Cart.addItems(t, ...this.product_ids),
              Drawer.open("right", "cart-drawer", this.add);
          } catch (t) {
            throw new Error(t);
          }
          this.add.setAttribute("aria-busy", !1);
        }
      });
  }
  buttonListener() {
    [...this.dots, ...this.hotspots].on(
      "click",
      ({ key: t, target: e, type: i }) => {
        if ("keydown" !== i || "Enter" === t) {
          const s = e.dataset.index;
          this.hotspots.forEach((t) => {
            t.setAttribute("data-transition-active", t.dataset.index === s);
          }),
            this.dots.forEach((t) => {
              t.setAttribute("aria-current", t.dataset.index === s);
            }),
            this.products.forEach((t) => {
              t.setAttribute("data-transition-active", t.dataset.index === s),
                t.setAttribute("aria-hidden", t.dataset.index !== s);
            });
        }
      }
    );
  }
  blockListener() {
    this.hotspots.on("theme:block:select", ({ target: t }) =>
      t.trigger("click")
    );
  }
}
customElements.define("shop-the-look-element", ShopTheLookSection);
class SubscribeForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.form = this.querySelector("form")),
      (this.input = this.querySelector(".subscribe-form--input")),
      (this.submit = this.querySelector("button")),
      this.clickListener();
  }
  clickListener() {
    this.submit.on("click", (t) => {
      t.preventDefault(),
        Utils.isValidEmail(this.input.value)
          ? this.submitForm()
          : FeedbackBar.load("email-invalid");
    });
  }
  submitForm() {
    this.form.submit(),
      this.form.setAttribute("aria-busy", !0),
      this.submit.setAttribute("disabled", "disabled");
  }
}
customElements.define("subscribe-form", SubscribeForm);
class XMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.open_menu = null),
      (this.menu_links = this.querySelectorAll(
        ".x-menu--level-1--link > a:has(+ .x-menu--level-2--container)"
      )),
      (this.menu_containers = this.querySelectorAll(
        ".x-menu--level-1--link:has(> .x-menu--level-2--container)"
      )),
      (this.menus = this.querySelectorAll(".x-menu--level-2--container")),
      this.mouseListeners(),
      this.focusListeners(),
      this.touchListeners(),
      Shopify.designMode && this.editorListeners();
  }
  mouseListeners() {
    this.menu_links.on("mouseenter.XMenu", ({ target: t }) => {
      this.close_timer ? (this.pending_open = t) : this.openMenu(t);
    }),
      this.menu_links.on("mouseleave.XMenu", ({ relatedTarget: t }) => {
        this.contains(t)
          ? this.close_timer ||
            (this.close_timer = setTimeout(() => {
              this.pending_open
                ? this.openMenu(this.pending_open)
                : this.closeMenu(),
                this.resetTimer();
            }, 80))
          : (this.closeMenu(), this.resetTimer());
      }),
      this.menus.on("mouseenter.XMenu", () => this.resetTimer()),
      this.menus.on("mouseleave.XMenu", () => this.closeMenu());
  }
  resetTimer() {
    this.close_timer && clearTimeout(this.close_timer),
      (this.close_timer = !1),
      (this.pending_open = !1);
  }
  focusListeners() {
    this.menu_links.on("focusin.XMenu", ({ target: t }) => this.openMenu(t)),
      this.menu_links.on(
        "focusout.XMenu",
        ({ target: t, relatedTarget: e }) => {
          t.parentNode.contains(e) || this.closeMenu();
        }
      ),
      this.menu_containers.on("focusout.XMenu", ({ relatedTarget: t }) => {
        (t && t.closest(".x-menu--level-2--container")) || this.closeMenu(!0);
      });
  }
  touchListeners() {
    this.menu_links.on(
      "touchstart.XMenu",
      (t) => {
        t.preventDefault(),
          "true" === t.target.getAttribute("aria-expanded")
            ? this.closeMenu()
            : this.openMenu(t.target);
      },
      { passive: !0 }
    );
  }
  editorListeners() {
    this.on("shopify:block:deselect", () => this.closeMenu()),
      this.on("shopify:block:select", ({ target: t }) => {
        var e = t.closest(".x-menu--level-2--container");
        this.openMenu(e.previousElementSibling);
      });
  }
  openMenu(t) {
    var e = t.nextElementSibling;
    this.open_menu && this.open_menu !== e
      ? this.closeMenu(!0)
      : this.open_menu &&
        this.open_menu === e &&
        this.open_menu.off("transitionend"),
      (this.open_menu = e),
      t.setAttribute("aria-expanded", !0),
      this.open_menu.removeAttribute("style"),
      setTimeout(() => this.open_menu.setAttribute("aria-hidden", !1), 0);
  }
  closeMenu(t) {
    null !== this.open_menu &&
      (this.open_menu.previousElementSibling.setAttribute("aria-expanded", !1),
      this.open_menu.setAttribute("aria-hidden", !0),
      t
        ? (this.findAndResetTransition(this.open_menu),
          this.open_menu.off("transitionend"),
          (this.open_menu.style.display = "none"),
          (this.open_menu = null))
        : this.open_menu.on(
            "transitionend",
            () => {
              null !== this.open_menu &&
                (this.findAndResetTransition(this.open_menu),
                (this.open_menu.style.display = "none"),
                (this.open_menu = null));
            },
            { once: !0 }
          ));
  }
  findAndResetTransition(t) {
    var e, i, s;
    t &&
      ((e = t.querySelectorAll("[data-transition-item]")).length &&
        e.forEach((t) => {
          t.removeAttribute("style");
        }),
      (i = t.querySelector("[data-transition-container]"))) &&
      ((s = i.getAttribute("data-transition-container")), Transitions.reset(s));
  }
}
customElements.define("x-menu-element", XMenu);
class yMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.back_links = this.querySelectorAll(".y-menu--back-link button")),
      (this.sub_menu_links = this.querySelectorAll(
        'li > button[aria-haspopup="true"]'
      )),
      (this.regular_links = this.querySelectorAll("li > a").not(
        this.sub_menu_links
      )),
      this.listeners();
  }
  disconnectedCallback() {
    [...this.regular_links, ...this.sub_menu_links, ...this.back_links].off(
      "click.YMenu"
    );
  }
  listeners() {
    this.regular_links.on("click.YMenu", ({ target: t }) => {
      const e = t.getAttribute("href");
      -1 !== e.indexOf("#") &&
        (Drawer.close(), setTimeout(() => (window.location.href = e), 450));
    }),
      this.sub_menu_links.on("click.YMenu", ({ target: t }) => {
        var e = t.getAttribute("aria-controls");
        t.setAttribute("aria-expanded", !0),
          (this.open_menu_button = t),
          this.openSubMenu(e);
      }),
      this.back_links.on("click.YMenu", ({ target: t }) => {
        var e = t.getAttribute("aria-controls");
        this.open_menu_button &&
          this.open_menu_button.setAttribute("aria-expanded", !1),
          this.closeSubMenu(e);
      });
  }
  adjustHeight(t) {
    let e = t.offsetHeight;
    var i = this.offsetHeight,
      s = ((this.style.height = i + "px"), window.getComputedStyle(t).position);
    "absolute" === s &&
      ((t.style.position = "relative"),
      (e = t.offsetHeight),
      (t.style.position = "absolute")),
      (this.style.height = e + "px");
  }
  openSubMenu(t) {
    var e = this.querySelector("#" + t);
    this.adjustHeight(e), (e.style.transform = "translateX(-100%)");
  }
  closeSubMenu(t) {
    var e = this.querySelector("#" + t),
      i = e.parentNode.closest("ul");
    this.adjustHeight(i), (e.style.transform = "translateX(0)");
  }
}
customElements.define("y-menu-element", yMenu);
export { Utils, Drawer, Cart };
window.trigger("theme:loaded");
